// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-25T18:12:49.079Z
// Property: Las Palmas  (ID: 6767906449167027)
// Collections: 20 amenities, 3 floorplans (live), 30 photos, 45 POIs, 3 reviews, 7 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162417",
  "multihub_property_id": "6767906449167027",
  "property_external_id": "1200081",
  "property_zillow_url": "https://www.zillow.com/apartments/san-diego-ca/las-palmas-apartments/CkBBvB/",
  "property_apartments_url": "https://www.apartments.com/las-palmas-apartments-san-diego-ca/d585thh/",
  "property_google_business_url": "https://www.google.com/search?hl=en-US&gl=us&q=Las+Palmas,+5275+Monroe+Ave,+San+Diego,+CA+92115&ludocid=10439379935133515341&lsig=AB86z5XLtbU7ZMEHQu6XxJd79sTE&source=g.page.m.kd._&laa=lu-desktop-review-solicitatio#laa=lu-desktop-review-solicitatio&lrd=0x80d95526a4745a65:0x90e020bda4f93e4d,3",
  "property_linkedin_url": null,
  "property_hubspot_id": "42196890135",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": "Entrata ",
  "property_status": null,
  "property_slug": "las-palmas",
  "property_name": "Las Palmas ",
  "property_website_url": "https://www.laspalmaslife.com/",
  "property_domain": "https://www.laspalmaslife.com/",
  "property_address": "5275 Monroe Ave",
  "property_full_address": "5275 Monroe Ave, San Diego, CA 92115",
  "property_address_1": "5275 Monroe Ave",
  "property_address_2": null,
  "property_address_city": "San Diego",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "92115",
  "property_address_country": "US",
  "property_address_county": "San Diego County",
  "property_neighborhood_address": "Talmadge",
  "property_address_latitude": "32.7586981",
  "property_address_longitude": "-117.0812419",
  "property_email": "laspalmas@sunrisemgmt.com",
  "property_phone": "619-332-0595",
  "property_call_tracking_phone": "619-792-1385",
  "property_company_name": "Sunrise Management",
  "property_company_url": "https://www.sunrisemgmt.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to Las Palmas, where charming Spanish Revival architecture meets modern comfort in San Diego, CA. Our gated community boasts newly remodeled interiors, exquisite landscaping, and dog-friendly spaces. Enjoy large open areas, private fenced backyards, and easy freeway access. Your unique sanctuary awaits—browse our availability or schedule a tour today!",
  "property_long_description": "Situated in San Diego&rsquo;s historic Talmadge neighborhood, Las Palmas is a collection of newly renovated two-bedroom apartment homes with washer/dryers and garages.  The property features charming Spanish revival architecture, secured, gated entry and is situated on a large lot with open space grass areas, a community BBQ, firepit and several vegetable gardens.\r\n\r\nLas Palmas is in a highly walkable neighborhood with restaurants and shopping located within blocks or the property.  The property is conveniently located near the major 15, 805 and 8 freeways and is a short drive to Downtown San Diego, North Park, Little Italy, Balboa Park, the Fashion Valley mall, San Diego State University and several beautiful beaches. Las Palmas&rsquo; unrivaled location puts the best of San Diego at your door.\r\n\r\nAdditionally, discover a rare opportunity to live in a space that feels like your very own home with our fully detached studio casita at Las Palmas. Unlike traditional studio apartments, this unique residence offers unmatched privacy with no shared walls or upstairs neighbors, a private entrance, and the charm of a standalone home. Say goodbye to circling around the block for parking and enjoy the ease of your own direct-access garage with additional storage. Step outside into your private fenced yard, the perfect space to enjoy your morning coffee or grow a small garden. Don&rsquo;t miss your chance to claim this one-of-a-kind studio!\r\nSan Diego Sunrise Management Co. dba Sunrise Management | Lic. No. 00927850 | Broker: Joseph S. Greenblatt License number 01064415",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8b-f43b-760d-9744-200d917b3ecd.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with a grassy courtyard and palm trees.",
    "public_id": "019ebf8b-f43b-760d-9744-200d917b3ecd",
    "storage_key": "property/6767906449167027/019ebf8b-f43b-760d-9744-200d917b3ecd.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167027/019f4881-aa3a-743a-a18a-296eb96f1dee.mp4",
  "property_featured_video_media": {
    "public_id": "019f4881-aa3a-743a-a18a-296eb96f1dee",
    "storage_key": "property/6767906449167027/019f4881-aa3a-743a-a18a-296eb96f1dee.mp4",
    "thumbnail_key": "property/6767906449167027/019f4881-aa3a-743a-a18a-296eb96f1dee_thumb.webp",
    "size_bytes": 69961029,
    "classification": "Apartment",
    "title": "Explore Our Spacious Apartments and Beautiful Community Grounds",
    "description": "Take a virtual tour of our apartment interiors, featuring modern kitchens and comfortable living spaces, complemented by our serene community grounds with lush landscaping and relaxing outdoor seating."
  },
  "property_total_units": "39",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.3076923076923",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": "Security deposit: $250.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "100",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Maximum 2 pets per unit. Dogs up to 75 lb weight limit; breed restrictions apply.",
  "property_pet_policy_description": "Pet deposit: $500.00 (refundable). Monthly pet rent: $50.00/month.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dog\nMax Number of Pets: 2\nMax weight of pets: 30 lbs\nPet deposit fee min: $500\nPet monthly rent min: $50\nPet policy fee min/max: $50 - $100",
  "property_online_leasing_url": "https://laspalmasapartments.prospectportal.com/San Diego/Las Palmas",
  "property_resident_portal_url": "https://laspalmasapartments.residentportal.com/auth",
  "property_apply_now_url": "https://laspalmasapartments.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/1200081/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019e98bf-5f98-75cd-ba2b-b4ca7961b85d.webp",
  "property_primary_logo_media": {
    "alt_text": "Las Palmas logo with two white palm trees and turquoise waves on a black background.",
    "public_id": "019e98bf-5f98-75cd-ba2b-b4ca7961b85d",
    "storage_key": "property/6767906449167027/019e98bf-5f98-75cd-ba2b-b4ca7961b85d.webp",
    "width": 1012,
    "height": 789
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019e98bf-93d8-767e-8a98-fad7ca5ae688.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Las Palmas logo with two palm trees and wavy lines",
    "public_id": "019e98bf-93d8-767e-8a98-fad7ca5ae688",
    "storage_key": "property/6767906449167027/019e98bf-93d8-767e-8a98-fad7ca5ae688.webp",
    "width": 1012,
    "height": 789
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019e98bf-88c9-7518-aed2-8d451a87b5d5.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Las Palmas logo with two palm trees and waves.",
    "public_id": "019e98bf-88c9-7518-aed2-8d451a87b5d5",
    "storage_key": "property/6767906449167027/019e98bf-88c9-7518-aed2-8d451a87b5d5.webp",
    "width": 1012,
    "height": 789
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
  "property_company_logo_media": {
    "alt_text": "Sunrise Management logo",
    "public_id": "019d06cf-4134-73f9-aa2c-2cbcff86a11a",
    "storage_key": "company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "width": 256,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#273447",
  "property_secondary_color": "#57d8d1",
  "property_font_color": "#333D4E",
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "253 - 870",
  "property_sqft_min": "253",
  "property_sqft_max": "870",
  "property_price_range": "$1899 - $2799",
  "property_price_min": "1899",
  "property_price_max": "2799",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/people/Las-Palmas-Apartments/100066877310353/",
  "property_instagram_url": "https://www.instagram.com/laspalmaslife",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZVp0pCZV2YARTT75pL0g4JA",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Las Palmas ",
  "property_home_romance_title": "Embrace the Joy of Living in Your Ideal Home",
  "property_home_amenities_blurb": "At Las Palmas in sunny San Diego, charm meets modern living in our gated community adorned with Spanish Revival architecture. Choose from stylish studios or spacious two-bedroom apartments featuring remodeled interiors, gourmet kitchens, and serene private backyards. Enjoy lush landscaping and easy freeway access—your tranquil retreat awaits!",
  "property_home_floorplans_blurb": "Welcome to Las Palmas in sunny San Diego, CA, where modern living meets vibrant community vibes. Choose from our stylish studio or spacious two-bedroom floor plans designed to elevate your lifestyle. Browse our available apartment homes today and find your perfect fit amidst beautiful surroundings and enticing amenities.",
  "property_home_gallery_blurb": "Nestled in the heart of San Diego, Las Palmas boasts charming Spanish Revival architecture and beautifully landscaped grounds. Choose from spacious two-bedroom or cozy studio floor plans with modern amenities like quartz countertops and in-unit washer/dryers. Picture yourself in this secure, dog-friendly community, complete with inviting BBQ areas!",
  "property_home_neighborhood_blurb": "At Las Palmas in vibrant San Diego, enjoy stylish studio and two-bedroom apartments surrounded by rich culture and endless excitement. Connect with nature at Balboa Park or immerse yourself in local art at San Diego's Central Library. Unwind with fitness options from 24 Hour Fitness to Jackie Robinson Family YMCA—all just steps away!",
  "property_home_reviews_blurb": "At Las Palmas in sunny San Diego, residents rave about our pristine grounds and responsive management, proclaiming, \"This place is quite the gem!\" With a perfect 5.0 rating, enjoy a community where peaceful living and attentive service come together seamlessly. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Las Palmas in sunny San Diego, your vibrant lifestyle awaits amidst premier educational hubs like San Diego State University and Grossmont College. Enjoy strolls in Balboa Park and unwind at the San Diego Air & Space Museum. See what's around our community and explore local favorites that enrich your everyday living!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Embrace the charm of San Diego at Las Palmas, where Spanish Revival architecture meets modern comfort. Enjoy gated security, newly remodeled interiors, and exquisite landscaping. With spacious layouts and pet-friendly features, you'll love the private fenced backyards and gourmet kitchens. Experience a vibrant lifestyle—your oasis awaits!",
  "property_applynow_blurb": "Welcome to Las Palmas in San Diego, where charming Spanish Revival architecture meets modern living. Choose from stylish studio or spacious two-bedroom layouts featuring gourmet kitchens with quartz countertops, in-unit laundry, and private backyards. With exquisite landscaping, a gated community, and gourmet BBQ areas, your perfect home awaits. Lease online today!",
  "property_contactus_blurb": "At Las Palmas in sunny San Diego, CA, we offer a variety of floor plans, including stylish studios and spacious two-bedroom apartments. Each design is tailored for comfort and modern living. Have questions? Reach out to our friendly leasing team today to learn more about your new home!",
  "property_faqs_blurb": "At Las Palmas in sunny San Diego, choose from stylish studio and spacious two-bedroom floor plans that cater to your lifestyle. Our FAQs page is your go-to resource for insights about our vibrant community. Dive in to find the answers you need and elevate your living experience today!",
  "property_floorplans_blurb": "At Las Palmas in sunny San Diego, CA, vibrant living awaits with our thoughtfully designed floor plans. Choose from stylish studios to spacious two-bedroom layouts, perfectly tailored to your lifestyle. Browse our available apartment homes and discover the ideal space that feels like home. Your new adventure starts here!",
  "property_gallery_blurb": "At Las Palmas in sunny San Diego, immerse yourself in the charm of Spanish Revival architecture paired with modern comforts. Our pet-friendly community boasts newly remodeled interiors, exquisite landscaping, and spacious layouts. With easy freeway access and private backyards in select units, your dream lifestyle awaits—picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to Las Palmas, where charming Spanish Revival architecture meets modern living in sunny San Diego. Choose from spacious two-bedroom or stylish studio apartments, featuring exquisite landscaping, private backyards, and newly remodeled interiors. Embrace the convenience of our gated community with easy freeway access and an interactive map to find your perfect home.",
  "property_pets_blurb": "At Las Palmas in sunny San Diego, your pets are more than welcome—they're family! With a spacious community featuring pet-friendly amenities and nearby parks, your furry friends will thrive. Enjoy a relaxing lifestyle with breathtaking views and a vibrant atmosphere, all while making lasting memories with your two beloved companions.",
  "property_referafriend_blurb": "At Las Palmas in sunny San Diego, our vibrant community offers spacious two-bedroom apartments and cozy studios tailored to your lifestyle. Unwind and thrive in a place where great friends become great neighbors. Share the love—refer a friend to join our welcoming family today!",
  "property_residentaccess_blurb": "Welcome to Las Palmas in sunny San Diego, CA! Our inviting community offers a range of floor plans, including spacious two-bedroom apartments and cozy studios. Effortlessly manage your home life through our resident portal—log in now to pay rent, schedule maintenance, and enjoy seamless living!",
  "property_reviews_blurb": "At Las Palmas in sunny San Diego, our residents rave about the experience! With impeccably maintained grounds and a friendly staff, one delighted tenant exclaimed, \"This place is quite the gem!\" Join our vibrant community and see why our 5-star ratings shine brightly. Discover what makes us the perfect home!",
  "property_created_at": "1770052656053",
  "property_scheduletour_blurb": "At Las Palmas in sunny San Diego, our floor plans cater to every lifestyle, offering inviting studios and spacious two-bedroom apartments. Dive into the vibrant community experience where comfort meets convenience. Ready to see why residents love calling Las Palmas home? Schedule your tour today and hear their stories!",
  "property_thankyou_blurb": "Thank you for reaching out! Las Palmas in sunny San Diego offers a variety of stylish floor plans, including two-bedroom and chic studio options. Get ready to elevate your living experience! Our team will connect with you soon to help you find your perfect home. ",
  "property_virtualtours_blurb": "Experience the vibrant lifestyle at Las Palmas in sunny San Diego, CA. With diverse floor plans, including cozy studios and spacious two-bedroom options, our community is designed for your comfort. Ready to find your perfect home? Take a virtual tour and envision your future today!",
  "property_copyright": "2026 All Rights Reserved. Las Palmas ",
  "property_seo_title_home": "Las Palmas  |  Apartments in San Diego, CA",
  "property_seo_description_home": "Discover charm at Las Palmas, San Diego! Enjoy renovated interiors, beautiful grounds, pet-friendly living, and easy freeway access. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | San Diego, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Las Palmas in sunny San Diego! Choose from stylish studios or spacious two-bedroom layouts. Your perfect floor plan awaits!",
  "property_seo_title_amenities": "Amenities | San Diego, CA Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Las Palmas in San Diego with stunning Spanish Revival architecture, spacious layouts, and pet-friendly amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in San Diego, CA",
  "property_seo_description_gallery": "Immerse yourself in Las Palmas, where Spanish Revival charm meets modern luxury in San Diego. Picture life in beautifully renovated spaces and lush grounds!",
  "property_seo_title_virtualtours": "Virtual Tours | Las Palmas  Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Las Palmas in San Diego! Take a virtual tour of our stunning studio and two-bedroom apartments. Your dream lifestyle awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Las Palmas  Apartments",
  "property_seo_description_interactivemap": "Discover the charm of Las Palmas in San Diego! Explore spacious, dog-friendly apartments with modern amenities and beautiful landscapes.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Diego, CA",
  "property_seo_description_neighborhood": "Uncover vibrant San Diego living at Las Palmas. From cozy studios to spacious two bedrooms, explore local favorites and discover your next adventure.",
  "property_seo_title_contact": "Contact Us | Las Palmas ",
  "property_seo_description_contact": "Reach out to Las Palmas in sunny San Diego! Our leasing team is ready to answer your questions about our studio and two-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in San Diego, CA",
  "property_seo_description_faqs": "Get answers to your questions at Las Palmas in San Diego! Explore our pet-friendly community with stunning design, modern amenities, and easy freeway access.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Diego, CA",
  "property_seo_description_reviews": "Experience life at Las Palmas in San Diego! Read resident reviews and discover why our charming, gated community with stunning amenities feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in San Diego, CA",
  "property_seo_description_applynow": "Discover Las Palmas in San Diego! Spacious floor plans, modern amenities, and beautiful landscapes—your new home is just a lease away!",
  "property_seo_title_residentaccess": "Resident Access | Las Palmas ",
  "property_seo_description_residentaccess": "Login to Las Palmas' resident portal for easy rent payments, maintenance requests, and community updates in sunny San Diego. Simplify your living today!",
  "property_seo_title_referafriend": "Refer A Friend | Las Palmas ",
  "property_seo_description_referafriend": "Refer a friend to Las Palmas in sunny San Diego! Share the community vibe where great friends become great neighbors. Join us for a vibrant lifestyle today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Las Palmas ",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Las Palmas in San Diego. Schedule your tour today and see how our community can elevate your living experience!",
  "property_seo_title_privacy": "Privacy Policy | Las Palmas ",
  "property_seo_description_privacy": "At Las Palmas in sunny San Diego, your privacy matters. Learn how we protect your information. Curious? View our privacy policy for the details!",
  "property_seo_title_accessibility": "Website Accessibility | Las Palmas ",
  "property_seo_description_accessibility": "At Las Palmas, San Diego, we prioritize digital inclusivity. Join us in creating an accessible community where everyone can thrive!",
  "property_seo_title_sitemap": "Sitemap | Las Palmas ",
  "property_seo_description_sitemap": "Navigate your way to your ideal home at Las Palmas in sunny San Diego! Check out our sitemap for easy access to all community features and amenities.",
  "property_seo_title_thankyou": "Thank You | Las Palmas ",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Las Palmas, San Diego's vibrant community, is appreciated. We'll connect soon to help you find your perfect home!",
  "property_seo_title_pets": "Pet Policy | Apartments in San Diego, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790114217475",
  "amenities": [
    {
      "id": "custom_ee8df70c-bf75-4a7d-9e7b-dc7c28afe534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Charming Spanish Revival Architecture",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6855e583-713a-4534-9eeb-33574063281e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Gated, Secured Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b67fc4f0-a9d9-4029-ae85-3907e6074d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Garage and Surface Parking Spots",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33776df3-a242-4fd1-b62b-ecf82ceac79a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Large Open Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c730e1c8-b7be-4b37-b256-611f3195a26b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Exquisite Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b50cf56b-5bc4-49ae-a0c2-3605264565c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Exterior",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09729d40-4b4a-4ded-97d5-6cf50377e95e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Dog/Cat Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb5f179f-09c7-49e7-8d0a-339074cc9b96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24a462c9-fb69-4738-b2d6-34887bdb22ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to the 15, 805 and 8 Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dfb90a69-4e26-427b-9da0-c1de062ee524",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Remodeled Interiors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ed7c086-c9f1-473e-9122-ae44b578a2ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer/Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b0fbb36-4a75-40b0-b22f-c2b5487a430b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e83f1095-fbbe-4b76-bab2-322eccd06231",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e6207be-8a36-49fa-8172-7dbd2e2e27ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "New Cabinets with Custom Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b78a4cb-944b-469a-a513-86d3c5a99f29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40f77b5e-b452-4cec-a426-12feec0f780c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher and Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41bba1ba-8316-4590-bc2e-b145a2cbce90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "New, Quiet, Dual Pane Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b2250c36-90ee-4974-b073-3d6dbdeb577c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3cbe657a-a7c0-44ad-a910-6a275da03bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Cable/Internet Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_797c20ae-3e93-466c-8ec9-6593f40d4ddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "external_id": "false",
      "title": "Private Fenced Backyards (select units)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_f853b75f6181f2cce893ab3f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-4b0e-75ed-81de-ade7bb9e62ce.webp",
      "image_media": {
        "alt_text": "Las Palmas apartment complex entrance with leasing office sign and palm trees.",
        "public_id": "019eba83-4b0e-75ed-81de-ade7bb9e62ce",
        "storage_key": "property/6767906449167027/019eba83-4b0e-75ed-81de-ade7bb9e62ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Las Palmas, where you can find your new home. Visit our leasing office today!",
      "link": "false",
      "alt_text": "Las Palmas apartment complex entrance with leasing office sign and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033335/6a2c7b2dcf0ea9.40219228493.jpg"
    },
    {
      "id": "ec_534655de3a3611e49005db61",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8a-96a5-76d2-8952-48608e107674.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with multiple units and Spanish-style architecture.",
        "public_id": "019ebf8a-96a5-76d2-8952-48608e107674",
        "storage_key": "property/6767906449167027/019ebf8a-96a5-76d2-8952-48608e107674.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring Spanish-style architecture, lush landscaping, and multiple unit entrances.",
      "link": "false",
      "alt_text": "Exterior of apartment building with multiple units and Spanish-style architecture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033333/6a2c7b2b60c902.01315524911.jpg"
    },
    {
      "id": "ec_40a0b5339e62ef374c8ef2a3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-578e-7727-8041-b8054207075e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel gas range, and decorative tile backsplash.",
        "public_id": "019eba83-578e-7727-8041-b8054207075e",
        "storage_key": "property/6767906449167027/019eba83-578e-7727-8041-b8054207075e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen featuring sleek white cabinetry, a striking patterned tile backsplash, and modern stainless steel appliances. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel gas range, and decorative tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032533/6a2c794bd63319.87237629960.jpg"
    },
    {
      "id": "ec_b2b3270fb95497613e547cfc",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-5779-70e8-93c0-3dac934c79e5.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and decorative backsplash.",
        "public_id": "019eba83-5779-70e8-93c0-3dac934c79e5",
        "storage_key": "property/6767906449167027/019eba83-5779-70e8-93c0-3dac934c79e5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Step into this beautifully updated kitchen featuring sleek white cabinetry, a chic tile backsplash, and modern stainless steel appliances. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless steel appliances and decorative backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032546/6a2c79586bc656.75546580712.jpg"
    },
    {
      "id": "ec_763635c4ea1ac59b9bceb886",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-563f-76fc-9ab4-baa1d8f13d4d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and stainless steel appliances.",
        "public_id": "019eba83-563f-76fc-9ab4-baa1d8f13d4d",
        "storage_key": "property/6767906449167027/019eba83-563f-76fc-9ab4-baa1d8f13d4d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring sleek white cabinetry, a decorative tile backsplash, and stainless steel appliances, including a gas range and refrigerator.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032548/6a2c795a89e0b6.41582799256.jpg"
    },
    {
      "id": "ec_e7cecd656bb99fc646d8b9c9",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8a-e8cb-7758-b899-0bd319079f73.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel refrigerator and gas range, white cabinets, and patterned tile backsplash.",
        "public_id": "019ebf8a-e8cb-7758-b899-0bd319079f73",
        "storage_key": "property/6767906449167027/019ebf8a-e8cb-7758-b899-0bd319079f73.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and modern kitchen featuring stainless steel appliances, clean white cabinetry, and a stylish patterned tile backsplash.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel refrigerator and gas range, white cabinets, and patterned tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032535/6a2c794e33f9e4.60494552523.jpg"
    },
    {
      "id": "ec_71c3057e388c0c9956ef9147",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-61f5-70da-96d3-d37b846ddba6.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a white laundry closet with shelving above.",
        "public_id": "019eba83-61f5-70da-96d3-d37b846ddba6",
        "storage_key": "property/6767906449167027/019eba83-61f5-70da-96d3-d37b846ddba6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a stackable washer and dryer, plus ample storage space.",
      "link": "false",
      "alt_text": "Stackable washer and dryer in a white laundry closet with shelving above.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033328/6a2c7b26c17ad6.42689922972.jpg"
    },
    {
      "id": "ec_dc8a4708e3163ad7d7cbca12",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8a-e809-767b-b346-18d97689294d.webp",
      "image_media": {
        "alt_text": "Living room with hardwood floors, ceiling fan, built-in shelves, and a view of the kitchen.",
        "public_id": "019ebf8a-e809-767b-b346-18d97689294d",
        "storage_key": "property/6767906449167027/019ebf8a-e809-767b-b346-18d97689294d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring gleaming hardwood floors, a modern ceiling fan, and convenient built-in shelving. Enjoy an open view into the updated kitchen.",
      "link": "false",
      "alt_text": "Living room with hardwood floors, ceiling fan, built-in shelves, and a view of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032531/6a2c79498a92e8.77971288211.jpg"
    },
    {
      "id": "ec_c884d10dd46a1d401374a497",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-7dd3-7215-b266-091fe7d1432e.webp",
      "image_media": {
        "alt_text": "Empty living room with hardwood floors, white walls, ceiling fan, and door.",
        "public_id": "019eba83-7dd3-7215-b266-091fe7d1432e",
        "storage_key": "property/6767906449167027/019eba83-7dd3-7215-b266-091fe7d1432e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with gleaming hardwood floors, a modern ceiling fan, and ample natural light from the windows. This room offers a blank canvas for you to create your dream living space.",
      "link": "false",
      "alt_text": "Empty living room with hardwood floors, white walls, ceiling fan, and door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032911/6a2c7a25e4b0f0.99422654806.jpg"
    },
    {
      "id": "ec_4d5e5629b09e68a358a00f9a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-73b4-7258-b5e2-e0b079b2c85a.webp",
      "image_media": {
        "alt_text": "Empty living room with hardwood floors, ceiling fan, built-in shelves, and windows.",
        "public_id": "019eba83-73b4-7258-b5e2-e0b079b2c85a",
        "storage_key": "property/6767906449167027/019eba83-73b4-7258-b5e2-e0b079b2c85a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring gleaming hardwood floors, a ceiling fan, and convenient built-in shelving. Large windows allow natural light to fill the room.",
      "link": "false",
      "alt_text": "Empty living room with hardwood floors, ceiling fan, built-in shelves, and windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032541/6a2c7954138976.66989628450.jpg"
    },
    {
      "id": "ec_325ca2c9328fd490febebb9c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-72f5-73cd-b489-f2ac7c61fd66.webp",
      "image_media": {
        "alt_text": "Living room with hardwood floors, white walls, ceiling fan, and view of kitchen.",
        "public_id": "019eba83-72f5-73cd-b489-f2ac7c61fd66",
        "storage_key": "property/6767906449167027/019eba83-72f5-73cd-b489-f2ac7c61fd66.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring gleaming hardwood floors, a modern ceiling fan, and an adjacent kitchen, perfect for comfortable living.",
      "link": "false",
      "alt_text": "Living room with hardwood floors, white walls, ceiling fan, and view of kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033319/6a2c7b1e5dbe81.39093465116.jpg"
    },
    {
      "id": "ec_39880d7b3f457cc509655cc3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-8153-743f-8193-1adfcc6750db.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors and a ceiling fan",
        "public_id": "019eba83-8153-743f-8193-1adfcc6750db",
        "storage_key": "property/6767906449167027/019eba83-8153-743f-8193-1adfcc6750db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with hardwood floors, a ceiling fan, and large windows offering views of the property's exterior.",
      "link": "false",
      "alt_text": "Empty bedroom with hardwood floors and a ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032907/6a2c7a2174bc01.94293205506.jpg"
    },
    {
      "id": "ec_9673480078b1867be6b58243",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-7f45-77a9-8e8b-2df546a16f1b.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors, ceiling fan, closet, and large window with balcony view.",
        "public_id": "019eba83-7f45-77a9-8e8b-2df546a16f1b",
        "storage_key": "property/6767906449167027/019eba83-7f45-77a9-8e8b-2df546a16f1b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring a ceiling fan, spacious closet, and gleaming hardwood floors. Large window offers a view of lush greenery.",
      "link": "false",
      "alt_text": "Empty bedroom with hardwood floors, ceiling fan, closet, and large window with balcony view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032909/6a2c7a239e77b9.24466514231.jpg"
    },
    {
      "id": "ec_54688d7f242613ab2775bc7d",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-75f4-7258-ad04-e3eededa0ad0.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors and a ceiling fan.",
        "public_id": "019eba83-75f4-7258-ad04-e3eededa0ad0",
        "storage_key": "property/6767906449167027/019eba83-75f4-7258-ad04-e3eededa0ad0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with hardwood floors, a ceiling fan, and abundant natural light. Enjoy views of the surrounding community from your window.",
      "link": "false",
      "alt_text": "Empty bedroom with hardwood floors and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032913/6a2c7a280030f6.50661107786.jpg"
    },
    {
      "id": "ec_8348c494923bfcaf77c51725",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-6e32-726c-adfe-db95eec93fb1.webp",
      "image_media": {
        "alt_text": "Bedroom with hardwood floors, closet, ceiling fan, and window. Bathroom visible through doorway.",
        "public_id": "019eba83-6e32-726c-adfe-db95eec93fb1",
        "storage_key": "property/6767906449167027/019eba83-6e32-726c-adfe-db95eec93fb1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring gleaming hardwood floors, a ceiling fan for comfort, and a convenient closet. The adjacent bathroom is easily accessible.",
      "link": "false",
      "alt_text": "Bedroom with hardwood floors, closet, ceiling fan, and window. Bathroom visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033322/6a2c7b20734ae6.53778603336.jpg"
    },
    {
      "id": "ec_2c3ff865eeb55dbef51db62f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-6951-75dc-8a43-546a35e5337c.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer unit in an apartment.",
        "public_id": "019eba83-6951-75dc-8a43-546a35e5337c",
        "storage_key": "property/6767906449167027/019eba83-6951-75dc-8a43-546a35e5337c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit stacked washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Stacked washer and dryer unit in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032915/6a2c7a2a36d100.91101391449.jpg"
    },
    {
      "id": "ec_968949250763daac3699ff06",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-659f-74b2-a595-64fde9b82eec.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment with polished hardwood floors and white walls, showing doorways to a bedroom and a bathroom.",
        "public_id": "019eba83-659f-74b2-a595-64fde9b82eec",
        "storage_key": "property/6767906449167027/019eba83-659f-74b2-a595-64fde9b82eec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step inside this charming apartment, featuring beautifully maintained hardwood floors and bright, airy white walls. The open layout provides access to a serene bedroom and a well-appointed bathroom, ready for your personal touch.",
      "link": "false",
      "alt_text": "Interior view of a vacant apartment with polished hardwood floors and white walls, showing doorways to a bedroom and a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033324/6a2c7b22a4c760.40520923682.jpg"
    },
    {
      "id": "ec_aaea3c86b9744fd9b8cc1e25",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-640b-775f-a389-d129faa67103.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
        "public_id": "019eba83-640b-775f-a389-d129faa67103",
        "storage_key": "property/6767906449167027/019eba83-640b-775f-a389-d129faa67103.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Updated bathroom featuring a sleek vanity with marble countertop, a modern faucet, and a bathtub. The space is bright and clean, perfect for relaxation.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032917/6a2c7a2c3077b3.04497713589.jpg"
    },
    {
      "id": "ec_753c0815d6d395c380e76b53",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8b-96e5-72d8-95e6-efe406dff176.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a toilet, bathtub, and window.",
        "public_id": "019ebf8b-96e5-72d8-95e6-efe406dff176",
        "storage_key": "property/6767906449167027/019ebf8b-96e5-72d8-95e6-efe406dff176.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a toilet, a white bathtub with a shower, and a window with blinds for natural light.",
      "link": "false",
      "alt_text": "Clean bathroom with a toilet, bathtub, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032857/6a2c7a18182c47.48257786683.jpg"
    },
    {
      "id": "ec_188cd4a64ec7710fb6e71da2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-6415-716a-8339-3e13e80a62f6.webp",
      "image_media": {
        "alt_text": "Clean and bright bathroom with a white vanity, sink, toilet, and shower/tub combo.",
        "public_id": "019eba83-6415-716a-8339-3e13e80a62f6",
        "storage_key": "property/6767906449167027/019eba83-6415-716a-8339-3e13e80a62f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a fresh and inviting bathroom, featuring a modern vanity, sink, toilet, and a pristine shower and tub combination.",
      "link": "false",
      "alt_text": "Clean and bright bathroom with a white vanity, sink, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033326/6a2c7b24bd3083.32879806428.jpg"
    },
    {
      "id": "ec_6e83615ca61c9bf541052443",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-91c6-71bd-9347-8b47ac551c5e.webp",
      "image_media": {
        "alt_text": "Outdoor built-in stainless steel grill with a side burner and storage cabinet, located on a paved patio area.",
        "public_id": "019eba83-91c6-71bd-9347-8b47ac551c5e",
        "storage_key": "property/6767906449167027/019eba83-91c6-71bd-9347-8b47ac551c5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our community's built-in stainless steel grill, perfect for gatherings with friends and neighbors.",
      "link": "false",
      "alt_text": "Outdoor built-in stainless steel grill with a side burner and storage cabinet, located on a paved patio area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032902/6a2c7a1caf0ee1.78431168137.jpg"
    },
    {
      "id": "ec_9708833328a3f6511108d29a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8b-e1f2-76af-b220-c0faf7fe9c82.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with wooden picnic table and benches under a pergola, surrounded by greenery and palm trees.",
        "public_id": "019ebf8b-e1f2-76af-b220-c0faf7fe9c82",
        "storage_key": "property/6767906449167027/019ebf8b-e1f2-76af-b220-c0faf7fe9c82.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our community's shaded picnic area, featuring a charming pergola and comfortable seating. Perfect for gathering with friends and family.",
      "link": "false",
      "alt_text": "Outdoor seating area with wooden picnic table and benches under a pergola, surrounded by greenery and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032904/6a2c7a1eecb449.87556604317.jpg"
    },
    {
      "id": "ec_76cc1ba2b6a261b527585b6f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-a1c0-70df-8fa6-46277eccf761.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a sidewalk and mailboxes.",
        "public_id": "019eba83-a1c0-70df-8fa6-46277eccf761",
        "storage_key": "property/6767906449167027/019eba83-a1c0-70df-8fa6-46277eccf761.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Walkway leading to apartment buildings with lush green grass and trees. Mailboxes are visible in the foreground.",
      "link": "false",
      "alt_text": "Apartment building exterior with a sidewalk and mailboxes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033315/6a2c7b1997a532.55040172919.jpg"
    },
    {
      "id": "ec_58e6925650fa1337b5d98c47",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-960e-721e-bddb-b14a405093c9.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and lounge chairs in a courtyard with palm trees and apartment buildings.",
        "public_id": "019eba83-960e-721e-bddb-b14a405093c9",
        "storage_key": "property/6767906449167027/019eba83-960e-721e-bddb-b14a405093c9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, complete with a cozy fire pit and comfortable lounge chairs. Enjoy the tropical ambiance of our courtyard, surrounded by lush greenery and swaying palm trees.",
      "link": "false",
      "alt_text": "Outdoor seating area with a fire pit and lounge chairs in a courtyard with palm trees and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033317/6a2c7b1c0d53e5.36502634292.jpg"
    },
    {
      "id": "ec_fb89ffb6d358d31835610363",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8b-f43b-760d-9744-200d917b3ecd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy courtyard and palm trees.",
        "public_id": "019ebf8b-f43b-760d-9744-200d917b3ecd",
        "storage_key": "property/6767906449167027/019ebf8b-f43b-760d-9744-200d917b3ecd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped courtyard surrounded by apartment buildings. Enjoy the lush green lawn and towering palm trees.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a grassy courtyard and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033330/6a2c7b28d8cea0.68119692696.jpg"
    },
    {
      "id": "ec_8e3e84135feb4404c4e21328",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-9d41-706d-b2c9-1c25a2f6afcb.webp",
      "image_media": {
        "alt_text": "Courtyard with fire pit and seating area at dusk.",
        "public_id": "019eba83-9d41-706d-b2c9-1c25a2f6afcb",
        "storage_key": "property/6767906449167027/019eba83-9d41-706d-b2c9-1c25a2f6afcb.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the evening air in the community courtyard, complete with a cozy fire pit and ample seating for relaxation.",
      "link": "false",
      "alt_text": "Courtyard with fire pit and seating area at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032537/6a2c795046a7c3.03754875448.jpg"
    },
    {
      "id": "ec_f8e886ad75f9c647d542275e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-9bb0-706d-a801-7f6c295c8150.webp",
      "image_media": {
        "alt_text": "Apartment building courtyards with picnic area and grill.",
        "public_id": "019eba83-9bb0-706d-a801-7f6c295c8150",
        "storage_key": "property/6767906449167027/019eba83-9bb0-706d-a801-7f6c295c8150.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor living in the courtyard, complete with picnic tables and a barbecue grill.",
      "link": "false",
      "alt_text": "Apartment building courtyards with picnic area and grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032539/6a2c795222b4e8.03967004230.jpg"
    },
    {
      "id": "ec_0a3e9670fd0c58ee30d6cc79",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019ebf8c-520e-763a-a10b-22f61398e456.webp",
      "image_media": {
        "alt_text": "A paved walkway leads through a manicured courtyard with lush greenery and palm trees to a building.",
        "public_id": "019ebf8c-520e-763a-a10b-22f61398e456",
        "storage_key": "property/6767906449167027/019ebf8c-520e-763a-a10b-22f61398e456.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stroll down the picturesque walkway, surrounded by vibrant landscaping and mature trees, leading to the charming buildings of our community. Enjoy the serene atmosphere and well-maintained grounds.",
      "link": "false",
      "alt_text": "A paved walkway leads through a manicured courtyard with lush greenery and palm trees to a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032859/6a2c7a1a2bf7e5.48924565793.jpg"
    },
    {
      "id": "ec_901332dbc0fbda1700f65b6e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019eba83-b032-71dc-8900-86ac79f1c2cd.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment complex with Spanish-style buildings and palm trees.",
        "public_id": "019eba83-b032-71dc-8900-86ac79f1c2cd",
        "storage_key": "property/6767906449167027/019eba83-b032-71dc-8900-86ac79f1c2cd.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this apartment community, featuring charming Spanish-style architecture and lush landscaping.",
      "link": "false",
      "alt_text": "Exterior view of an apartment complex with Spanish-style buildings and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032550/6a2c795c9396a8.92137298321.jpg"
    },
    {
      "id": "ec_16423c677beb325dd6907d9a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019e98bc-9bce-711b-9270-ece1a39b3053.webp",
      "image_media": {
        "alt_text": "Outdoor gathering area with fire pit and seating.",
        "public_id": "019e98bc-9bce-711b-9270-ece1a39b3053",
        "storage_key": "property/6767906449167027/019e98bc-9bce-711b-9270-ece1a39b3053.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "COVER",
      "link": "false",
      "alt_text": "COVER",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/21/2023/08/18/030858/64dfddead9efa4.37107025729.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2731c49f-52e6-4efc-9da2-fb58d0c0a12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Tacos El Gordo",
      "poi_type": "Restaurants",
      "poi_address": "511 F St, San Diego, CA 92102, USA",
      "poi_short_description": "No-frills Mexican counter-serve joint featuring Tijuana tacos, mulas, loaded fries & more.",
      "poi_long_description": "People say this Mexican restaurant serves delicious Carne Asada Tacos, Taco De Adobada, and al pastor. They highlight the fair prices and the lively, energetic atmosphere. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-27e0-701d-afdb-59d03936cfc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-27e0-701d-afdb-59d03936cfc4",
        "storage_key": "property/6767906449167027/019d08bd-27e0-701d-afdb-59d03936cfc4.webp",
        "width": 1280,
        "height": 971
      },
      "poi_business_url": "https://tacoselgordobc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3385535148072060085&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacos-el-gordo",
      "poi_latitude": "32.713482",
      "poi_longitude": "-117.1598238",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 619-955-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d414-7349-811d-a010b34c8aa6",
        "storage_key": "property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRy7n2KZT2YARtURvo0fW-y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4831f5f3-defc-4d2b-ba02-0ac6943fb46e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "2005 Camino Del Este, San Diego, CA 92108, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious cheeseburgers, animal style fries, and shakes. They highlight the fresh ingredients, consistent quality, and affordable prices. They also like the friendly staff and fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-2971-72ba-a8b8-b08e485198ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-2971-72ba-a8b8-b08e485198ee",
        "storage_key": "property/6767906449167027/019d08bd-2971-72ba-a8b8-b08e485198ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/128",
      "poi_directions_map_url": "https://maps.google.com/?cid=14808858715406340789&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "32.7694946",
      "poi_longitude": "-117.1434563",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d414-7349-811d-a010b34c8aa6",
        "storage_key": "property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68ArIxpV2YARtRK-fIqig80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_42ea3f41-970d-47ea-8724-f5670602387d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Morning Glory",
      "poi_type": "Restaurants",
      "poi_address": "550 W Date St Suite #C, San Diego, CA 92101, USA",
      "poi_short_description": "Eatery with wooden seating serving global breakfast, brunch, and boozy coffee.",
      "poi_long_description": "Diners say this breakfast restaurant serves up delicious soufflé pancakes, khachapuri, and breakfast carbonara. They also highlight the stylish and playful decor, friendly service, and overall vibrant and memorable brunch experience.\n\nSome reviews mention the wait times can be long, especially on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-28a8-7355-98d7-6e34de7c47c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-28a8-7355-98d7-6e34de7c47c7",
        "storage_key": "property/6767906449167027/019d08bd-28a8-7355-98d7-6e34de7c47c7.webp",
        "width": 1280,
        "height": 1144
      },
      "poi_business_url": "http://www.morningglorybreakfast.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10904478176897912104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "morning-glory",
      "poi_latitude": "32.7231382",
      "poi_longitude": "-117.1681668",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-629-0302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d414-7349-811d-a010b34c8aa6",
        "storage_key": "property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8ufvdZV2YARKM3_oiB9VJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_9af10358-116c-4ac6-a7d7-6e296b04d48a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "La Puerta",
      "poi_type": "Restaurants",
      "poi_address": "560 Fourth Ave, San Diego, CA 92101, USA",
      "poi_short_description": "Chill Mexican spot offers signature drinks & tequila alongside family recipes, plus DJs after hours.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, and quesadillas, and offers a wide selection of tequila and mezcal. They highlight the generous portions, reasonable prices, and fun, vibrant atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-27a2-7136-b64e-013d436fa2c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-27a2-7136-b64e-013d436fa2c8",
        "storage_key": "property/6767906449167027/019d08bd-27a2-7136-b64e-013d436fa2c8.webp",
        "width": 1078,
        "height": 606
      },
      "poi_business_url": "https://lapuertasd.com/?utm_source=Business-Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4238869013816314905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-puerta",
      "poi_latitude": "32.7112162",
      "poi_longitude": "-117.1612498",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 619-696-3466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d414-7349-811d-a010b34c8aa6",
        "storage_key": "property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4xl21lT2YARGYzu2eh80zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_28cd6519-5b74-4ce0-a00f-93edb0fc8627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "5323 Mission Center Rd, San Diego, CA 92108, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves good chicken sandwiches, nuggets, and fries. They highlight the food is tasty and the staff are nice and professional. They also like the clean restrooms and outdoor seating area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-3048-7138-b6d8-7cf11b031ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3048-7138-b6d8-7cf11b031ec3",
        "storage_key": "property/6767906449167027/019d08bd-3048-7138-b6d8-7cf11b031ec3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ca/mission-center-road?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10500091743298136996&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.7710774",
      "poi_longitude": "-117.1544385",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-213-1565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d414-7349-811d-a010b34c8aa6",
        "storage_key": "property/6767906449167027/019d08bc-d414-7349-811d-a010b34c8aa6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQfpus1V2YARpCtMBM_Rt5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_15540ae8-71d3-4c64-ab07-3db1311009b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Fashion Valley",
      "poi_type": "Shopping & Retail",
      "poi_address": "7007 Friars Rd, San Diego, CA 92108, USA",
      "poi_short_description": "Large shopping center with chain department stores, a movie theater & casual dining options.",
      "poi_long_description": "People say this shopping center offers a wide selection of high-end brands and some restaurants. They highlight the clean and beautiful outdoor mall, and the convenient parking and access via train. They also like the friendly staff and the safe, secure atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-301f-74bb-960a-491abea49a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-301f-74bb-960a-491abea49a43",
        "storage_key": "property/6767906449167027/019d08bd-301f-74bb-960a-491abea49a43.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.simon.com/mall/fashion-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=2624403255049499074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fashion-valley",
      "poi_latitude": "32.7681182",
      "poi_longitude": "-117.1667284",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-688-9113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba2-7069-9a78-71d362e69d19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba2-7069-9a78-71d362e69d19",
        "storage_key": "property/6767906449167027/019d08bc-dba2-7069-9a78-71d362e69d19.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-Vi3YjFV2YARwrGaFNvAayQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f63b4578-e55e-4fab-b2d0-a8e637fe85e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "2149 Fenton Pkwy, San Diego, CA 92108, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "People say this furniture store offers a wide variety of home furnishings, including stylish and affordable furniture, decor, and kitchenware, with a cafeteria that serves tasty Swedish treats. They also highlight the store's well-stocked and clean environment, easy navigation, friendly and helpful staff, and ample parking.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-30cb-701a-97bf-0947772bedaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-30cb-701a-97bf-0947772bedaf",
        "storage_key": "property/6767906449167027/019d08bd-30cb-701a-97bf-0947772bedaf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/san-diego/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=san-diego",
      "poi_directions_map_url": "https://maps.google.com/?cid=12805901528794216427&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "32.7802228",
      "poi_longitude": "-117.1263415",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba2-7069-9a78-71d362e69d19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba2-7069-9a78-71d362e69d19",
        "storage_key": "property/6767906449167027/019d08bc-dba2-7069-9a78-71d362e69d19.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO1rpVadV2YAR6zdphJezt7E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_42c0f385-a204-49e0-8269-c52086d299fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "711 University Ave, San Diego, CA 92103, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, as well as a variety of prepared foods, sandwiches, and baked goods. They also highlight the friendly and helpful staff, and the convenient Amazon return service.\n\nOther reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-30fc-761b-a63f-c958cc825f21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-30fc-761b-a63f-c958cc825f21",
        "storage_key": "property/6767906449167027/019d08bd-30fc-761b-a63f-c958cc825f21.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/sandiego?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1443879554160269889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.7478888",
      "poi_longitude": "-117.1580245",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-294-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d40e-7549-8f9f-e229592eba5b",
        "storage_key": "property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4ooPdtU2YARQRos9M2wCRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_381cb6f2-5ffb-4983-b838-1e9dda7e45ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "H Mart Balboa",
      "poi_type": "Shopping & Retail",
      "poi_address": "7725 Balboa Ave, San Diego, CA 92111, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "People say this Korean grocery store offers a wide variety of fresh produce, meats, seafood, and authentic Korean snacks, sauces, and ready-made banchan. They highlight the reasonable prices, clean and well-stocked aisles, and the convenient food court with delicious options like Korean fried chicken and spicy tofu soup. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-370a-7447-9143-9c86c5ef79e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-370a-7447-9143-9c86c5ef79e5",
        "storage_key": "property/6767906449167027/019d08bd-370a-7447-9143-9c86c5ef79e5.webp",
        "width": 960,
        "height": 467
      },
      "poi_business_url": "https://www.hmart.com/store/balboa-ca-92111/770d0836-1d1f-4e21-bd1d-dc661a9044f8",
      "poi_directions_map_url": "https://maps.google.com/?cid=380016199523366923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-balboa",
      "poi_latitude": "32.8207173",
      "poi_longitude": "-117.1574763",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 858-836-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d40e-7549-8f9f-e229592eba5b",
        "storage_key": "property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp146cC7_24ARC_h7VbgWRgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_0d993c29-7d58-437c-8e24-0a1e4983847f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Ralphs",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 G St, San Diego, CA 92101, USA",
      "poi_short_description": "Chain grocery offering produce, meat, alcohol & other groceries, plus a bakery & pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, dry goods, and international products. They also highlight the convenient downtown location, underground parking, and the availability of self-checkout.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-3839-70db-adbd-6e4b92782c72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3839-70db-adbd-6e4b92782c72",
        "storage_key": "property/6767906449167027/019d08bd-3839-70db-adbd-6e4b92782c72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ralphs.com/stores/grocery/ca/san-diego/downtown-san-diego/703/00123?cid=loc_70300123_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9689476224317185364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ralphs",
      "poi_latitude": "32.7120961",
      "poi_longitude": "-117.1633583",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-595-1581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d40e-7549-8f9f-e229592eba5b",
        "storage_key": "property/6767906449167027/019d08bc-d40e-7549-8f9f-e229592eba5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc59qoldT2YARVN0E-knvd4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_eae0d3e2-ba27-45db-8e70-ea46e98befe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego State University",
      "poi_type": "Education",
      "poi_address": "5500 Campanile Dr, San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-620a-701c-a487-37d71ffd3c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-620a-701c-a487-37d71ffd3c1f",
        "storage_key": "property/6767906449167027/019d08bc-620a-701c-a487-37d71ffd3c1f.webp",
        "width": 1125,
        "height": 1074
      },
      "poi_business_url": "http://www.sdsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14096032391797864726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-state-university",
      "poi_latitude": "32.77641210000001",
      "poi_longitude": "-117.0719191",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-594-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba0-700c-8ae4-6c535cb5468e",
        "storage_key": "property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUqgpoZW2YARFvmCv8Yqn8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fa56dbfe-3552-45d1-ba94-1863387829ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Grossmont College",
      "poi_type": "Education",
      "poi_address": "8800 Grossmont College Dr, El Cajon, CA 92020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-39b6-743a-859f-1461010b7965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-39b6-743a-859f-1461010b7965",
        "storage_key": "property/6767906449167027/019d08bd-39b6-743a-859f-1461010b7965.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.grossmont.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8825233813808899569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "grossmont-college",
      "poi_latitude": "32.8166735",
      "poi_longitude": "-117.0065725",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba0-700c-8ae4-6c535cb5468e",
        "storage_key": "property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ71G4qutX2YAR8WXYQ2WHeXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f177e084-08de-4fb0-aaa6-36d837394902",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego City College",
      "poi_type": "Education",
      "poi_address": "1313 Park Blvd, San Diego, CA 92101, USA",
      "poi_short_description": "Long-standing community college offering a variety of associate degrees & vocational programs.",
      "poi_long_description": "Long-standing community college offering a variety of associate degrees & vocational programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-687f-7108-9b97-f477451031c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-687f-7108-9b97-f477451031c7",
        "storage_key": "property/6767906449167027/019d08bc-687f-7108-9b97-f477451031c7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.sdcity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1400390698412405690&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-city-college",
      "poi_latitude": "32.7175697",
      "poi_longitude": "-117.1508543",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-388-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba0-700c-8ae4-6c535cb5468e",
        "storage_key": "property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe13-YqBU2YARuvOhresvbxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_94b45407-7545-4e9e-8dd8-5805e760040c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego Mesa College",
      "poi_type": "Education",
      "poi_address": "7250 Mesa College Dr, San Diego, CA 92111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-41c2-716c-a12b-0a428a593d12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-41c2-716c-a12b-0a428a593d12",
        "storage_key": "property/6767906449167027/019d08bd-41c2-716c-a12b-0a428a593d12.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sdmesa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=224688495791531198&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-mesa-college",
      "poi_latitude": "32.8049085",
      "poi_longitude": "-117.1675503",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 619-388-2682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba0-700c-8ae4-6c535cb5468e",
        "storage_key": "property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZxzyPlP424ARvmTFGP9AHgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_de670416-0628-441e-ad2d-cc57b874a4c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego Central Library",
      "poi_type": "Education",
      "poi_address": "330 Park Blvd, San Diego, CA 92101, USA",
      "poi_short_description": "Massive, light-filled public library offering floors of books, an art gallery & an open-air terrace.",
      "poi_long_description": "Visitors say this public library offers stunning architecture, a variety of study rooms, and incredible views of the bay and Coronado Bridge from the top floors. They also highlight the friendly and helpful staff, the abundance of resources, and the overall peaceful atmosphere.\n\nSome reviews mention there can be homeless people in the library.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-44c9-736e-932e-239cf444d687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-44c9-736e-932e-239cf444d687",
        "storage_key": "property/6767906449167027/019d08bd-44c9-736e-932e-239cf444d687.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiego.gov/public-library/central-library",
      "poi_directions_map_url": "https://maps.google.com/?cid=1939771009330628390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-central-library",
      "poi_latitude": "32.7086753",
      "poi_longitude": "-117.1542218",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 619-236-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dba0-700c-8ae4-6c535cb5468e",
        "storage_key": "property/6767906449167027/019d08bc-dba0-700c-8ae4-6c535cb5468e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq_1kX1xT2YARJsfApHRz6xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_34b9c138-8ecd-4c13-b8ae-ed617207f149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2920 Zoo Dr, San Diego, CA 92101, USA",
      "poi_short_description": "Zoo featuring giraffes, koalas, apes & more, plus tours & a conservation society.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including pandas, polar bears, and koalas, and the exhibits are spacious and well-maintained. They highlight the beautiful landscaping, the fun and informative bus tour, and the Skyfari aerial tram, which provides great views. They also like the friendly and helpful staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-70a8-7198-bc83-30ca006040f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-70a8-7198-bc83-30ca006040f4",
        "storage_key": "property/6767906449167027/019d08bc-70a8-7198-bc83-30ca006040f4.webp",
        "width": 1280,
        "height": 1048
      },
      "poi_business_url": "https://zoo.sandiegozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6769178757639299655&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-zoo",
      "poi_latitude": "32.7360353",
      "poi_longitude": "-117.1509849",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 619-231-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYB_SZVU2YARR-I1Jjf08F0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_b4fd8b2f-1073-433a-af98-6ad1459a51b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Petco Park",
      "poi_type": "Entertainment",
      "poi_address": "100 Park Blvd, San Diego, CA 92101, USA",
      "poi_short_description": "Opened in 2004, this prominent outdoor stadium features seasonal sporting events & concerts.",
      "poi_long_description": "People say this stadium offers a wide variety of delicious food options, including hot dogs, nachos, and tri-tip nachos, and a great selection of drinks. They highlight the spacious layout, modern design, and excellent views of the field and downtown skyline, as well as the fun and engaging energy of the crowd. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-44c6-732c-9937-a2b7a9aae74f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-44c6-732c-9937-a2b7a9aae74f",
        "storage_key": "property/6767906449167027/019d08bd-44c6-732c-9937-a2b7a9aae74f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mlb.com/padres",
      "poi_directions_map_url": "https://maps.google.com/?cid=13110664405617659484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "petco-park",
      "poi_latitude": "32.7076173",
      "poi_longitude": "-117.1570405",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-795-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-845d-7423-933d-4b7a6af7b014.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-845d-7423-933d-4b7a6af7b014",
        "storage_key": "property/6767906449167027/019d08bd-845d-7423-933d-4b7a6af7b014.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7fMsvKtU2YARXM4yStBv8rU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_61ef7fb0-ed3f-4862-b8fd-5a016e7f7350",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Snapdragon Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2101 Stadium Wy, San Diego, CA 92108, USA",
      "poi_short_description": "Open-air stadium accommodating football, rugby and women's soccer games as well as concerts.",
      "poi_long_description": "People say this stadium offers a good selection of food options and the food is very good for stadium food. They also highlight the beautiful and clean venue, and the great atmosphere with good views from every seat.\n\nSome reviews mention the traffic can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-44a8-700c-a1b5-74985b5981d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-44a8-700c-a1b5-74985b5981d8",
        "storage_key": "property/6767906449167027/019d08bd-44a8-700c-a1b5-74985b5981d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://snapdragonstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9833790300765105489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snapdragon-stadium",
      "poi_latitude": "32.7841307",
      "poi_longitude": "-117.1224366",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-845d-7423-933d-4b7a6af7b014.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-845d-7423-933d-4b7a6af7b014",
        "storage_key": "property/6767906449167027/019d08bd-845d-7423-933d-4b7a6af7b014.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15v_AMRV2YARUS3JSC2keIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_35667569-fc49-466b-8011-9c66d38f92cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego Air & Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "2001 Pan American Plaza, San Diego, CA 92101, USA",
      "poi_short_description": "Popular place with historical aircraft/spacecraft & interactive exhibits, plus a gift shop & grill.",
      "poi_long_description": "People say this museum offers a wide variety of aircraft, spacecraft, and interactive exhibits, showcasing the history of flight from its earliest days to modern aviation and space exploration. They highlight the engaging and educational experience, suitable for all ages, and the well-curated collections. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-4946-76a7-98d7-0c8471e6ef07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4946-76a7-98d7-0c8471e6ef07",
        "storage_key": "property/6767906449167027/019d08bd-4946-76a7-98d7-0c8471e6ef07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiegoairandspace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1679417536021818045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-air--space-museum",
      "poi_latitude": "32.7262258",
      "poi_longitude": "-117.1543736",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-234-8291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e0f3-702f-b7dc-c8094dd43283.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e0f3-702f-b7dc-c8094dd43283",
        "storage_key": "property/6767906449167027/019d08bc-e0f3-702f-b7dc-c8094dd43283.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZPqMqNU2YARvWok4Fl9Thc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8bfa3543-7787-4706-851b-1c1ab98c816e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Viejas Arena",
      "poi_type": "Entertainment",
      "poi_address": "5500 Canyon Crest Dr, San Diego, CA 92182, USA",
      "poi_short_description": "12,000+ capacity venue for sports, concerts & events on the San Diego State University campus.",
      "poi_long_description": "People say this arena is a great venue for concerts and basketball games, offering comfortable seating and decent views from all sections. They highlight the fun and energetic atmosphere, especially during games, and the helpful and friendly staff. They also like the easy access and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-4bfd-76ca-adb6-2e5501104af2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4bfd-76ca-adb6-2e5501104af2",
        "storage_key": "property/6767906449167027/019d08bd-4bfd-76ca-adb6-2e5501104af2.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://as.sdsu.edu/viejas_arena/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5659767995776599249&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "viejas-arena",
      "poi_latitude": "32.7740276",
      "poi_longitude": "-117.0746442",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-594-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJASLBHoFW2YAR0YRjYwGJi04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_bc9efa7e-884d-436e-8220-856854f0a229",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Toby Wells YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "5105 Overland Ave, San Diego, CA 92123, USA",
      "poi_short_description": "Fitness center with a swimming pool and yoga studio, plus kids' classes and childcare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-4c70-743c-a002-ca77f9d43fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4c70-743c-a002-ca77f9d43fab",
        "storage_key": "property/6767906449167027/019d08bd-4c70-743c-a002-ca77f9d43fab.webp",
        "width": 820,
        "height": 340
      },
      "poi_business_url": "https://www.ymcasd.org/locations/toby-wells-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=15557039165434838300&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toby-wells-ymca",
      "poi_latitude": "32.8298073",
      "poi_longitude": "-117.1303186",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 858-496-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVT34RLT_24ARHD2VPLK05dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_cdfa353d-6d3c-4214-956b-5799404bb25d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2348 Russell Park Way Ste 100, San Diego, CA 92108, USA",
      "poi_short_description": "Vibrant chain gym that features an indoor pool and sauna, plus classes and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including cardio machines, weight training equipment, and a functional training area, and is generally clean and well-maintained.\n\nOther reviews mention the gym can be crowded and the sauna can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5188-71de-af47-969945f04ce3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5188-71de-af47-969945f04ce3",
        "storage_key": "property/6767906449167027/019d08bd-5188-71de-af47-969945f04ce3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1279&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7277710649717690007&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.7762093",
      "poi_longitude": "-117.1477167",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 858-609-7157",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBzuCmABV2YARlw6A5kaf_2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f56a134c-93b3-4058-ae56-2462f275d953",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Jackie Robinson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "151 YMCA Way, San Diego, CA 92102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5472-76ac-a045-fb526ce9a031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5472-76ac-a045-fb526ce9a031",
        "storage_key": "property/6767906449167027/019d08bd-5472-76ac-a045-fb526ce9a031.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.ymcasd.org/locations/jackie-robinson-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=14725755974240564054&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jackie-robinson-family-ymca",
      "poi_latitude": "32.704859",
      "poi_longitude": "-117.097059",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-264-0144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVX_38NT2YARVvOxxQllXMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_090311e2-5cc4-49a6-92d0-a6b2c21b549e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Copley-Price Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 El Cajon Blvd, San Diego, CA 92105, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-4c70-743c-a002-ca77f9d43fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4c70-743c-a002-ca77f9d43fab",
        "storage_key": "property/6767906449167027/019d08bd-4c70-743c-a002-ca77f9d43fab.webp",
        "width": 820,
        "height": 340
      },
      "poi_business_url": "https://www.ymcasd.org/locations/copley-price-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=3796442856132178256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "copley-price-family-ymca",
      "poi_latitude": "32.7554681",
      "poi_longitude": "-117.1013753",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-280-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy6EgvmlU2YARUPHTyamsrzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_21e05041-daf8-41dd-8e3e-768da91007a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1233 Camino del Rio S, San Diego, CA 92108, USA",
      "poi_short_description": "Spacious, clean, modern fitness center for cardio, free weights and yoga with a massage area and smoothies.",
      "poi_long_description": "People say this fitness center offers a wide variety of new and well-maintained equipment, including cardio machines, weights, and barbells, as well as amenities like hydromassage, sauna, and tanning. They also highlight the friendly, professional, and helpful staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5433-7268-ac93-3d681a734561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5433-7268-ac93-3d681a734561",
        "storage_key": "property/6767906449167027/019d08bd-5433-7268-ac93-3d681a734561.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/san-diego-mission-valley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16097250344141495768&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.7648237",
      "poi_longitude": "-117.1524024",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 858-256-7587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXEHySNV2YAR2J0Wr-brZN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_8a14394c-fb8f-4bee-ac49-5452d4e3ae53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Fit Athletic Club & Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "350 Tenth Ave, San Diego, CA 92101, USA",
      "poi_short_description": "Spacious gym, at 24/7 Fitness, featuring a pool, a sauna, steam room and yoga classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including Gym80 machines, and a rooftop pool with stunning views. They also highlight the clean facilities, spacious workout areas, and diverse group fitness classes led by excellent instructors.\n\nOther reviews mention the gym can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5b15-77bb-9ff6-51f98b12c22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5b15-77bb-9ff6-51f98b12c22a",
        "storage_key": "property/6767906449167027/019d08bd-5b15-77bb-9ff6-51f98b12c22a.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://fitathletic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2197764373565144737&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fit-athletic-club--gym",
      "poi_latitude": "32.708972",
      "poi_longitude": "-117.155685",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 619-764-5348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLd3sd1xT2YARof5bsg0HgB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f1900f00-f757-4f88-83fb-a2a1608b30dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6348 College Grove Way Suite 109, San Diego, CA 92115, USA",
      "poi_short_description": "Clean chain fitness center featuring cardio machines, free weights and a pool.",
      "poi_long_description": "People say this gym offers a variety of machines, weights, and a sauna and steam room. They also highlight the friendly and helpful staff, and the energetic vibe.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5b15-77bb-9ff6-5480342317af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5b15-77bb-9ff6-5480342317af",
        "storage_key": "property/6767906449167027/019d08bd-5b15-77bb-9ff6-5480342317af.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/san-diego-ca/college-grove-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=16660680102220306494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "32.738163",
      "poi_longitude": "-117.055963",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-229-6112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGf7KoUpR2YARPphC6UegNuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_951f2564-9ec1-4776-a7e2-19f17e90a704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1725 Euclid Ave, San Diego, CA 92105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-83a0-712a-9f06-eaf68c23889c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-83a0-712a-9f06-eaf68c23889c",
        "storage_key": "property/6767906449167027/019d08bc-83a0-712a-9f06-eaf68c23889c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/san-diego-euclid-ave-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985480885468469923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.7231972",
      "poi_longitude": "-117.0828468",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-564-6619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7trz_xT2YARoxoxaalEdJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c07b8711-2df2-4db4-a717-9f29909b983f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Rady Children’s Hospital - San Diego",
      "poi_type": "Health and Wellness",
      "poi_address": "3020 Children's Way, San Diego, CA 92123, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-c8b6-7348-95d3-f4b83a9c110b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-c8b6-7348-95d3-f4b83a9c110b",
        "storage_key": "property/6767906449167027/019d08bc-c8b6-7348-95d3-f4b83a9c110b.webp",
        "width": 752,
        "height": 395
      },
      "poi_business_url": "https://www.rchsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9989700038247520902&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rady-childrens-hospital---san-diego",
      "poi_latitude": "32.7979816",
      "poi_longitude": "-117.1512449",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 858-576-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e0ef-716b-aa7b-f67ffc4293fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e0ef-716b-aa7b-f67ffc4293fd",
        "storage_key": "property/6767906449167027/019d08bc-e0ef-716b-aa7b-f67ffc4293fd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZqBu9dU2YARhhpz0EGLooo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c3c9bc86-61af-43db-b1e6-756b39dc8a80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Naval Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "34800 Bob Wilson Dr, San Diego, CA 92134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5d39-707c-a3e9-5bee36afc12c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5d39-707c-a3e9-5bee36afc12c",
        "storage_key": "property/6767906449167027/019d08bd-5d39-707c-a3e9-5bee36afc12c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.med.navy.mil/NMRTC-San-Diego-CA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13554511416348797782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "naval-medical-center",
      "poi_latitude": "32.7283083",
      "poi_longitude": "-117.1439324",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 619-532-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e7a3-77db-997d-0c7c7056ba3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e7a3-77db-997d-0c7c7056ba3d",
        "storage_key": "property/6767906449167027/019d08bc-e7a3-77db-997d-0c7c7056ba3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1gnL6dU2YARVmtye1FMG7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e7fa15ec-08f0-4441-9849-4e6f40bb15a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Balboa Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Diego, CA, USA",
      "poi_short_description": "Sprawling outdoor destination is home to the city's renowned zoo, museums, gardens & more.",
      "poi_long_description": "Visitors say this park offers stunning Spanish architecture, beautiful gardens including a rose garden and Japanese garden, and a variety of museums. They also highlight the peaceful and relaxing atmosphere, with many enjoying picnics, walks, and cultural events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-5d65-7579-93be-59f3c3864414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5d65-7579-93be-59f3c3864414",
        "storage_key": "property/6767906449167027/019d08bd-5d65-7579-93be-59f3c3864414.webp",
        "width": 554,
        "height": 554
      },
      "poi_business_url": "https://balboapark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17146060561609782980&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "balboa-park",
      "poi_latitude": "32.7341479",
      "poi_longitude": "-117.144553",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-239-0512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e159-74be-8dae-7ac3c47afe64",
        "storage_key": "property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA8tw-pZU2YARxPYVsDwL8-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5123216a-c487-487d-98cf-cbe7e766598f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Waterfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 Pacific Hwy, San Diego, CA 92101, USA",
      "poi_short_description": "Public park featuring spray fountains, grassy areas & lots of play equipment for kids.",
      "poi_long_description": "People say this park offers a fun water feature, a playground, and open lawns perfect for picnics and relaxation. They highlight the clean and safe environment, the beautiful waterfront views, and the convenient location near the Maritime Museum. They also like the accessible bathrooms and the presence of security. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-60e8-76ed-9f35-74d248fe40c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-60e8-76ed-9f35-74d248fe40c2",
        "storage_key": "property/6767906449167027/019d08bd-60e8-76ed-9f35-74d248fe40c2.webp",
        "width": 727,
        "height": 545
      },
      "poi_business_url": "https://www.sdparks.org/content/sdparks/en/park-pages/Waterfront.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11077509131500010682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waterfront-park",
      "poi_latitude": "32.722281",
      "poi_longitude": "-117.172761",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-232-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e159-74be-8dae-7ac3c47afe64",
        "storage_key": "property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6VEXa1U2YARujw0K903u5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_97964deb-622e-474b-8246-a4600f32f7e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Botanical Building",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 El Prado, San Diego, CA 92101, USA",
      "poi_short_description": "Domed building from the 1915 Panama-California Exposition & a garden with more than 2,000 plants.",
      "poi_long_description": "People say this botanical garden offers a diverse collection of exotic plants and flowers, and a serene atmosphere perfect for a peaceful stroll. They highlight the beautiful architecture, the free admission, and the picturesque pond with ducks and koi. They also like the recent renovations, which have created a more open and airy space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-62b3-723d-a05b-e7ecdcbd15db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-62b3-723d-a05b-e7ecdcbd15db",
        "storage_key": "property/6767906449167027/019d08bd-62b3-723d-a05b-e7ecdcbd15db.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://balboaparkbotanical.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6337263628494328718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "botanical-building",
      "poi_latitude": "32.73248",
      "poi_longitude": "-117.1492249",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-239-0512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e159-74be-8dae-7ac3c47afe64",
        "storage_key": "property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_R6EJZU2YARjlNooLF78lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_5d0929c2-2ee1-41c2-a895-855bed3e66ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Civita Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7960 Civita Blvd, San Diego, CA 92108, USA",
      "poi_short_description": "Popular city park with a splash pad, food trucks, several playgrounds & an amphitheater.",
      "poi_long_description": "Visitors say this city park offers a splash pad, playgrounds, walking paths, and grassy areas perfect for picnics, with clean bathrooms and stunning views. They also highlight the family-friendly atmosphere, well-maintained grounds, and diverse activities for all ages, including live music and a farmers market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-659d-724a-a42c-d6f257ced8ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-659d-724a-a42c-d6f257ced8ae",
        "storage_key": "property/6767906449167027/019d08bd-659d-724a-a42c-d6f257ced8ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.civitalife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960954305541227051&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "civita-park",
      "poi_latitude": "32.7790075",
      "poi_longitude": "-117.1468663",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-531-1563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e159-74be-8dae-7ac3c47afe64",
        "storage_key": "property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_5zARVV2YARK8ISBd4hHZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3796d0c3-218f-45d4-b19c-763ede1595b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Chicano Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1949 Logan Ave, San Diego, CA 92113, USA",
      "poi_short_description": "Colorful murals can be seen at this public park located beneath the San Diego-Coronado Bridge.",
      "poi_long_description": "People say this park features stunning murals that tell powerful stories about Chicano culture and history. They highlight the vibrant and meaningful atmosphere, and the opportunity to learn about the area's history through the artwork. They also like the playground, skate park, and nearby shops and restaurants. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-6383-74e9-9bdf-3a72809ca92a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6383-74e9-9bdf-3a72809ca92a",
        "storage_key": "property/6767906449167027/019d08bd-6383-74e9-9bdf-3a72809ca92a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.chicano-park.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15478226640263320260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicano-park",
      "poi_latitude": "32.700288",
      "poi_longitude": "-117.1422818",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e159-74be-8dae-7ac3c47afe64",
        "storage_key": "property/6767906449167027/019d08bc-e159-74be-8dae-7ac3c47afe64.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAAKRT2YARxBLiRR-1zdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a215a9e1-fc89-4615-878a-b07d41938590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Montgomery-Gibbs Executive Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3750 John J Montgomery Dr, San Diego, CA 92123, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-6b76-763a-a496-9b29e288fb03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b76-763a-a496-9b29e288fb03",
        "storage_key": "property/6767906449167027/019d08bd-6b76-763a-a496-9b29e288fb03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiego.gov/airports/montgomery",
      "poi_directions_map_url": "https://maps.google.com/?cid=8253993712247210177&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "montgomery-gibbs-executive-airport",
      "poi_latitude": "32.8127497",
      "poi_longitude": "-117.1414113",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 858-573-1440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e77b-73ab-a5e8-1b5a5edcc52d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e77b-73ab-a5e8-1b5a5edcc52d",
        "storage_key": "property/6767906449167027/019d08bc-e77b-73ab-a5e8-1b5a5edcc52d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-oBCGBT2YARwYDNvIwTjHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2de0a4e2-d59a-443b-bbdb-ea06407e6577",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "County Center/Little Italy Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1550 California St, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-6a91-74e4-948b-07af674215f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6a91-74e4-948b-07af674215f1",
        "storage_key": "property/6767906449167027/019d08bd-6a91-74e4-948b-07af674215f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sdmts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12527476736962369033&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "county-centerlittle-italy-station",
      "poi_latitude": "32.72142",
      "poi_longitude": "-117.16995",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Vg9pa1U2YARCZacBriJ2q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4897f95c-038b-469e-87d1-b45ebea7c65f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "12th & Imperial",
      "poi_type": "Transportation & Transit",
      "poi_address": "MTS Center Way, San Diego, CA 92113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-6e49-71e8-a7ef-8484430b6f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6e49-71e8-a7ef-8484430b6f17",
        "storage_key": "property/6767906449167027/019d08bd-6e49-71e8-a7ef-8484430b6f17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sdmts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4191733472462018568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "12th--imperial",
      "poi_latitude": "32.7052699",
      "poi_longitude": "-117.1541327",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 619-233-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcDeOkNT2YARCJg2a2IHLDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9d64c22b-5e27-40ac-8f4e-b476bcc16e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "SDSU Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-6e1a-73d2-8408-e6a8b23d13ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6e1a-73d2-8408-e6a8b23d13ec",
        "storage_key": "property/6767906449167027/019d08bd-6e1a-73d2-8408-e6a8b23d13ec.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7338960994505490894&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sdsu-station",
      "poi_latitude": "32.7733253",
      "poi_longitude": "-117.0705252",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcnZiYZW2YARzoHyGSQ62WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_dd6eb118-c70b-4ac3-8d0e-b6968605ddc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Fashion Valley Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-71d8-735e-828a-bc8282587eb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-71d8-735e-828a-bc8282587eb5",
        "storage_key": "property/6767906449167027/019d08bd-71d8-735e-828a-bc8282587eb5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16707006045088720163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fashion-valley-station",
      "poi_latitude": "32.76548",
      "poi_longitude": "-117.16906",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TmkDDJV2YARIyXRAXs12-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_1a547f01-60b6-46b6-a904-0b3fc3f31bd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "San Diego City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "202 C St, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-c79a-73b5-be72-6fa02c64261f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-c79a-73b5-be72-6fa02c64261f",
        "storage_key": "property/6767906449167027/019d08bc-c79a-73b5-be72-6fa02c64261f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sandiego.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144209643291727739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-diego-city-hall",
      "poi_latitude": "32.7172775",
      "poi_longitude": "-117.1631761",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-236-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-e7a3-77db-997d-0c7c7056ba3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e7a3-77db-997d-0c7c7056ba3d",
        "storage_key": "property/6767906449167027/019d08bc-e7a3-77db-997d-0c7c7056ba3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRZnn_BU2YARe9e2TIULBnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1f9cea47-275f-4676-b154-6ed5f4c0464a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "1 Columbia Place",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 W A St Ste 350, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-74a9-7439-9803-fe50ad6c9d09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-74a9-7439-9803-fe50ad6c9d09",
        "storage_key": "property/6767906449167027/019d08bd-74a9-7439-9803-fe50ad6c9d09.webp",
        "width": 1280,
        "height": 743
      },
      "poi_business_url": "https://www.1columbiaplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12498804349414283070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-columbia-place",
      "poi_latitude": "32.7179647",
      "poi_longitude": "-117.1666732",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-610-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3j2UalU2YARPhfyk1WsdK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5dd706b6-5f23-4567-822a-43c32d6683b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Shield AI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 W Broadway #600, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-74cc-714b-8aef-24a6034c4ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-74cc-714b-8aef-24a6034c4ddd",
        "storage_key": "property/6767906449167027/019d08bd-74cc-714b-8aef-24a6034c4ddd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://shield.ai/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1934998509133693748&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shield-ai",
      "poi_latitude": "32.7162822",
      "poi_longitude": "-117.1686995",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0jbJ6pU2YARNAPTWeR-2ho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_05ddb694-48f3-408f-8092-173196088b8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Sharp HealthCare - Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8695 Spectrum Center Blvd, San Diego, CA 92123, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-74a9-7439-9804-00614f500b61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-74a9-7439-9804-00614f500b61",
        "storage_key": "property/6767906449167027/019d08bd-74a9-7439-9804-00614f500b61.webp",
        "width": 725,
        "height": 407
      },
      "poi_business_url": "http://www.sharp.com/?y_source=1_MTMwODIwNjAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13062483983064640597&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharp-healthcare---corporate-office",
      "poi_latitude": "32.8254013",
      "poi_longitude": "-117.1403808",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-827-4277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJByerZ7j_24ARVSzMfvlDR7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_de77199d-655d-4da1-8e6c-1355d5663e9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "poi_name": "Southwest Regional Maintenance Center Flag Pole",
      "poi_type": "Major Employers & Offices",
      "poi_address": "S 32nd St, San Diego, CA 92136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bd-7a79-7500-b617-be937f87ed45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-7a79-7500-b617-be937f87ed45",
        "storage_key": "property/6767906449167027/019d08bd-7a79-7500-b617-be937f87ed45.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=222993225586802015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwest-regional-maintenance-center-flag-pole",
      "poi_latitude": "32.6835675",
      "poi_longitude": "-117.126949",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-db9a-74be-a8dc-a84a4d29cce4",
        "storage_key": "property/6767906449167027/019d08bc-db9a-74be-a8dc-a84a4d29cce4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8zToKpT2YARX31rPig7GAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_fb7699bac68b390cf1fbfe8b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "16:30"
    },
    {
      "id": "ec_2c555b898476579837d458cd",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "16:30"
    },
    {
      "id": "ec_dbaf4dfa3eeda550cdf0910a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "16:30"
    },
    {
      "id": "ec_3c3c7ea8c1f6dd60e00d90a4",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "16:30"
    },
    {
      "id": "ec_3d1127f92e4d24305561577f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "16:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_3fb81020-9e50-4f11-809b-41266a06f85c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "rating": "5.0",
      "name": "Olympia Serrano",
      "text": "This place is quite the Gem! Beautiful, clean & easily navigated grounds. Friendly staff & quiet tennants. I would most def. Recommend to anyone looking for a nice place;)",
      "date": "2025-09-01",
      "title": ""
    },
    {
      "id": "custom_a536f85a-f59b-4c20-9dc5-e1ae1e90d53d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "rating": "5.0",
      "name": "Junior Bennin",
      "text": "Been living at Las Palmas for three years and the management is great. They’re attentive and responsive. When things happens trust that it’ll get handled in a timely manner. I highly recommend",
      "date": "2025-09-06",
      "title": ""
    },
    {
      "id": "custom_fe88035e-ecc2-40c8-a7c5-b20a7d19f99b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "rating": "5.0",
      "name": "Hamza Mahmood",
      "text": "Great experience so far—everything’s well-maintained and smooth. The manager was super helpful with move-in!",
      "date": "2025-08-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b93100dd-f6e0-4429-ae38-81b4eaad482c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-32f8-72fe-b89c-0d4c7544638f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-32f8-72fe-b89c-0d4c7544638f",
        "storage_key": "property/6767906449167027/019d45ef-32f8-72fe-b89c-0d4c7544638f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g92o9Xzor7k"
    },
    {
      "id": "custom_1b088c31-56d6-496d-80ef-56f630c9da83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d08be-4fed-710d-8c52-9ce58b3bb220.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen entrance of apartment",
        "public_id": "019d08be-4fed-710d-8c52-9ce58b3bb220",
        "storage_key": "property/6767906449167027/019d08be-4fed-710d-8c52-9ce58b3bb220.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas #37",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=mGQ8BQzQKYQ"
    },
    {
      "id": "custom_58f5c4b0-7d37-4316-baaa-23e9847b6e6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-6449-72a5-bbd0-4656b37e5da8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-6449-72a5-bbd0-4656b37e5da8",
        "storage_key": "property/6767906449167027/019d45ef-6449-72a5-bbd0-4656b37e5da8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas #38",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZYcZrMDVfLk"
    },
    {
      "id": "custom_db5daa60-c328-437e-8c74-024a46f16f8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-7a86-76ef-b720-cbacbccfca63.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-7a86-76ef-b720-cbacbccfca63",
        "storage_key": "property/6767906449167027/019d45ef-7a86-76ef-b720-cbacbccfca63.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas Casita #39",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4xhZcouscTt"
    },
    {
      "id": "custom_26f33243-cf61-4022-94c7-7a41ea06b109",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-9186-7608-bfe0-1bf1f5503576.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-9186-7608-bfe0-1bf1f5503576",
        "storage_key": "property/6767906449167027/019d45ef-9186-7608-bfe0-1bf1f5503576.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas #40",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yeDc9unfNZ4"
    },
    {
      "id": "custom_d623a672-84a3-47e4-9d53-cd647953d408",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-ac97-710c-a7aa-f5c3fa02a495.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-ac97-710c-a7aa-f5c3fa02a495",
        "storage_key": "property/6767906449167027/019d45ef-ac97-710c-a7aa-f5c3fa02a495.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas - 2BR/1BTH- STAGED",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EgU7PyHmnzo"
    },
    {
      "id": "custom_a76a9251-a429-496d-ab0c-aa04b523c686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167027/019d45ef-bc1b-7698-ada5-29c719c0a722.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45ef-bc1b-7698-ada5-29c719c0a722",
        "storage_key": "property/6767906449167027/019d45ef-bc1b-7698-ada5-29c719c0a722.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Las Palmas - 2BR/1BTH",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=P3T2XVQi4RH&brand=0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ecc2c-5e21-73cd-bae3-f704426af88b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Las Palmas  Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027"
    },
    {
      "lead_collector_id": "01a0b044-b1e8-70f7-9712-56d4c3c25ecf",
      "lead_source": "LANDING_PAGE",
      "name": "Las Palmas  Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-san-diego-ca-las-palmas",
      "search_query": "dog friendly apartments San Diego CA",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in San Diego, CA",
      "h2_subtitle": "Discover the perfect dog friendly apartments at Las Palmas. Located in San Diego, CA, our community welcomes you and your furry friend.",
      "page_copy": "Embrace the vibrant lifestyle in San Diego, CA, with Las Palmas, the quintessential dog friendly apartments you've been seeking. Situated in the charming Talmadge neighborhood, our community offers a delightful home for both you and your pet. Las Palmas stands out with its charming Spanish Revival architecture, offering a picturesque and pet-welcoming environment.\n\nOur pet-friendly community ensures convenience with in-unit washer/dryers and stainless steel appliances, making it easy for pet owners to manage everyday tasks. The new dual pane windows ensure tranquility, perfect for you and your pet to relax after a stroll around this lovely neighborhood. With cable/internet ready apartments, staying connected is a breeze. Live a rewarding life with your furry companion at Las Palmas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in San Diego, CA",
      "seo_description": "Explore Las Palmas, dog-friendly apartments in San Diego, CA. Enjoy Spanish Revival style, in-unit washer/dryers, and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-apartments-talmadge-las-palmas",
      "search_query": "in-unit washer dryer apartments Talmadge",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartments Talmadge",
      "h2_subtitle": "Experience convenience with in-unit washer dryer apartments at Las Palmas in Talmadge. Simplify your life in this charming San Diego neighborhood.",
      "page_copy": "Las Palmas in Talmadge is the ideal choice for those seeking in-unit washer dryer apartments. Located in the heart of San Diego, our community ensures that laundry day is stress-free with modern appliances right at your fingertips. The convenience of having an in-unit washer and dryer makes managing household chores effortless, giving you more time to enjoy the vibrant surroundings.\n\nOur apartments boast charming Spanish Revival architecture, creating a warm and inviting atmosphere. Enjoy the comfort of stainless steel appliances and the serenity provided by new dual pane windows. Seamlessly connected, our cable and internet ready units cater to your every need. Discover how Las Palmas can transform your living experience in the beautiful Talmadge neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartments Talmadge",
      "seo_description": "Discover Las Palmas' in-unit washer dryer apartments in Talmadge. Enjoy Spanish Revival design and modern amenities in San Diego.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "gated-community-apartments-near-92115-las-palmas",
      "search_query": "gated community apartments near 92115",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments Near 92115",
      "h2_subtitle": "Las Palmas offers a secure gated community near 92115. Enjoy modern amenities and a welcoming atmosphere in San Diego's Talmadge neighborhood.",
      "page_copy": "Nestled near the bustling center of San Diego, Las Palmas provides secure gated community apartments near 92115, ideal for those seeking comfort and peace of mind. Located in the picturesque Talmadge neighborhood, our community assures residents a blend of safety and style with our Spanish Revival architecture and thoughtfully designed units.\n\nResidents enjoy a host of conveniences, including in-unit washer/dryers and sleek stainless steel appliances, all wrapped in the quiet tranquility afforded by state-of-the-art dual pane windows. Our cable and internet-ready living spaces ensure you stay connected, while the tight-knit community vibe makes you feel right at home. Choose Las Palmas for a harmonious blend of security and leisure near San Diego's vibrant heart.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments Near 92115",
      "seo_description": "Explore Las Palmas' gated community apartments near 92115, San Diego. Safe, stylish living with amenities like in-unit washer/dryers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-san-diego-county-las-palmas",
      "search_query": "apartments with stainless steel appliances San Diego County",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Discover apartments with stainless steel appliances at Las Palmas. Located in San Diego County, enjoy modern living with top-notch amenities.",
      "page_copy": "Las Palmas in San Diego County offers apartments with stainless steel appliances, the ideal solution for those seeking contemporary finishes and functionality. Our modern appliances not only add a sleek aesthetic to your kitchen but also make meal prep and clean-up a breeze.\n\nBeyond the appealing kitchen, our community features charming Spanish Revival architecture and well-appointed living spaces equipped with in-unit washer/dryers and dual pane windows ensuring a peaceful environment. Nestled in the Talmadge neighborhood, Las Palmas also provides cable and internet-ready units, delivering the perfect combination of convenience and style. Choose Las Palmas and indulge in a sophisticated living experience fit for San Diego's vibrant landscape.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances",
      "seo_description": "Find Las Palmas' apartments with stainless steel appliances in San Diego County. Modern living with in-unit washer/dryers and charming architecture.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "quartz-countertops-luxury-apartments-san-diego-las-palmas",
      "search_query": "quartz countertops luxury apartments in San Diego",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Quartz Countertops",
      "h2_subtitle": "Experience luxury with quartz countertops in San Diego's Las Palmas. Discover elegance and high-end finishes in a prime location.",
      "page_copy": "Las Palmas offers luxury apartments in San Diego, featuring exquisite quartz countertops that elevate both aesthetics and functionality. These top-of-the-line finishes add a touch of class to your living space, making meal preparation and entertaining a delightful experience.\n\nImmerse yourself in the unique charm of our Spanish Revival architecture, while enjoying modern conveniences such as in-unit washer/dryers and stainless steel appliances. Situated in the picturesque Talmadge neighborhood, our community provides quiet dual pane windows and connected living with cable and internet-ready units. Embrace the perfect blend of elegance and comfort at Las Palmas, where luxury living is redefined in San Diego.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Quartz Countertops",
      "seo_description": "Discover quartz countertops in Las Palmas' luxury apartments, San Diego. Enjoy elegance, modern amenities, and charming architecture.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "studio-apartments-talmadge-las-palmas",
      "search_query": "studio apartments in Talmadge",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Talmadge",
      "h2_subtitle": "Find cozy studio apartments in Talmadge at Las Palmas. Enjoy modern amenities in a friendly San Diego neighborhood.",
      "page_copy": "Las Palmas offers charming studio apartments in Talmadge, perfect for those seeking a cozy yet stylish living space in San Diego. Our thoughtfully designed studios are adorned with Spanish Revival architecture, adding unique character and warmth.\n\nEnjoy modern conveniences including stainless steel appliances and in-unit washer/dryers, ensuring effortless living. Dual pane windows provide a serene atmosphere, while cable and internet-ready units keep you connected. Located in the vibrant yet peaceful Talmadge neighborhood, Las Palmas offers a welcoming community feel with access to all San Diego County has to offer. Choose Las Palmas for a perfect blend of comfort and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Talmadge",
      "seo_description": "Explore studio apartments in Talmadge, San Diego at Las Palmas. Enjoy modern amenities and charming architecture in a peaceful community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-92115-las-palmas",
      "search_query": "two bedroom apartments near 92115",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 92115",
      "h2_subtitle": "Explore spacious two bedroom apartments near 92115 at Las Palmas. Enjoy modern amenities and charming architecture in San Diego County.",
      "page_copy": "At Las Palmas, we offer spacious two bedroom apartments near the 92115 area, perfect for families or roommates seeking comfort and style in San Diego. With charming Spanish Revival architecture, our community provides a unique living experience that combines elegance with modern luxury.\n\nOur two bedroom units come equipped with stainless steel appliances, in-unit washer/dryers, and dual pane windows that ensure a quiet and comfortable atmosphere. Nestled in the Talmadge neighborhood, Las Palmas is cable and internet-ready, providing both connectivity and convenience. Embrace the vibrant San Diego lifestyle with a home that balances classic charm and contemporary amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 92115",
      "seo_description": "Find two bedroom apartments near 92115 at Las Palmas in San Diego. Enjoy spacious living with modern amenities and charming architecture.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-sdsu-talmadge-las-palmas",
      "search_query": "apartments near san diego state university talmadge",
      "category": "School",
      "h1_title": "Apartments Near SDSU in Talmadge",
      "h2_subtitle": "Discover Las Palmas, offering apartments near San Diego State University in Talmadge. Enjoy modern living in a prime location.",
      "page_copy": "Las Palmas is an ideal choice for those seeking apartments near San Diego State University in the Talmadge neighborhood. Perfectly situated in San Diego, our community offers students and professionals alike easy access to campus life and city conveniences.\n\nOur apartments feature charming Spanish Revival architecture with modern updates such as stainless steel appliances and in-unit washer/dryers. Enjoy the quiet provided by our dual pane windows, and stay connected with cable and internet-ready units. Experience the best of both worlds at Las Palmas, where you can enjoy close proximity to SDSU along with the tranquility of the Talmadge community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near SDSU in Talmadge",
      "seo_description": "Explore Las Palmas apartments near San Diego State University in Talmadge. Enjoy a blend of modern amenities and proximity to SDSU.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-close-to-grossmont-college-las-palmas",
      "search_query": "apartments close to grossmont college san diego county",
      "category": "School",
      "h1_title": "Apartments Close to Grossmont College",
      "h2_subtitle": "Discover comfortable living at Las Palmas, conveniently close to Grossmont College and located in the vibrant San Diego County area.",
      "page_copy": "Las Palmas offers ideal apartments close to Grossmont College, providing students and staff with comfortable and convenient living in San Diego County. Our community, nestled in the charming Talmadge neighborhood, offers a perfect blend of modern convenience and classic style.\n\nExperience the blend of Spanish Revival architecture with modern amenities like in-unit washer/dryers and stainless steel appliances, ensuring a hassle-free lifestyle. Our dual pane windows ensure peace and quiet, and being cable and internet-ready keeps you connected. Las Palmas is your gateway to both educational pursuits at Grossmont College and the vibrant cultural life of San Diego County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Grossmont College",
      "seo_description": "Find Las Palmas apartments close to Grossmont College. Enjoy modern living in San Diego County's vibrant environment with our unique amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-by-san-diego-city-college-las-palmas",
      "search_query": "apartments by san diego city college ca",
      "category": "School",
      "h1_title": "Apartments by San Diego City College",
      "h2_subtitle": "Explore Las Palmas, conveniently located near San Diego City College. Ideal student and professional living with unique amenities.",
      "page_copy": "Located in the vibrant Talmadge area, Las Palmas provides a perfect living solution for those seeking apartments by San Diego City College. Our community is designed for both students and professionals who value convenience and comfort.\n\nEnjoy the appealing Spanish Revival architecture complemented by modern features such as stainless steel appliances and quiet, dual pane windows. With in-unit washer/dryers and cable/internet-ready options, Las Palmas ensures a seamless and connected living experience. Experience the dynamic San Diego lifestyle with easy access to education and city amenities at Las Palmas, where tradition meets modernity.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by San Diego City College",
      "seo_description": "Discover Las Palmas, offering apartments by San Diego City College with modern amenities. Perfect for students and professionals in CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-san-diego-mesa-college-las-palmas",
      "search_query": "apartments near san diego mesa college 92115",
      "category": "School",
      "h1_title": "Apartments Near San Diego Mesa College",
      "h2_subtitle": "Welcome to Las Palmas, featuring apartments near San Diego Mesa College in the 92115 area. Experience modern living with classic charm.",
      "page_copy": "Las Palmas is your go-to community for those searching for apartments near San Diego Mesa College, conveniently located in the 92115 area. Our community offers a perfect blend of proximity to educational opportunities and the serenity of the Talmadge neighborhood.\n\nStep into our charming Spanish Revival architecture with modern comforts including in-unit washer/dryers and stainless steel appliances. The dual pane windows provide a peaceful indoor environment while the cable and internet-ready units keep you connected. At Las Palmas, enjoy being close to San Diego Mesa College while experiencing the conveniences and luxuries you deserve.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near San Diego Mesa College",
      "seo_description": "Find ideal living at Las Palmas, offering apartments near San Diego Mesa College in the 92115 area, combining classic charm with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-rady-childrens-hospital-las-palmas",
      "search_query": "apartments near Rady Children's Hospital San Diego",
      "category": "Hospital",
      "h1_title": "Apartments Near Rady Children's Hospital",
      "h2_subtitle": "Discover Las Palmas, where our apartments provide ease of access to Rady Children's Hospital San Diego, ideal for medical professionals and families.",
      "page_copy": "Las Palmas offers the ideal setting for those seeking apartments near Rady Children's Hospital in San Diego. Situated in the tranquil Talmadge neighborhood, our community provides unmatched convenience for healthcare professionals and families.\n\nOur residences feature charming Spanish Revival design paired with modern amenities like in-unit washer/dryers and stainless steel appliances. Quiet dual pane windows ensure a peaceful living space, while cable and internet-ready homes keep you connected. Experience easy commutes to Rady Children's Hospital along with the comfort and style of Las Palmas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rady Children's Hospital",
      "seo_description": "Discover Las Palmas, with apartments near Rady Children's Hospital San Diego offering modern amenities and a convenient location for professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "san-diego-county-apartments-naval-medical-center",
      "search_query": "San Diego County apartments close to Naval Medical Center",
      "category": "Hospital",
      "h1_title": "San Diego County Apartments near Naval Medical",
      "h2_subtitle": "Experience Las Palmas, located conveniently close to Naval Medical Center. Ideal for military personnel seeking comfort in San Diego County.",
      "page_copy": "For those searching San Diego County apartments close to Naval Medical Center, Las Palmas in Talmadge presents an excellent option. Our community offers a serene environment that is perfect for military personnel and their families looking for proximity to the Naval Medical Center.\n\nLas Palmas features distinctive Spanish Revival architecture with a touch of modern elegance. Residents enjoy amenities such as stainless steel appliances, in-unit washer/dryers, and quiet, dual pane windows. With its cable and internet-ready units, Las Palmas ensures you stay well-connected. Nestled within a peaceful neighborhood, our community is an ideal choice for demanding schedules, providing a comfortable refuge after a busy day at the Naval Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "San Diego County Apartments near Naval Medical",
      "seo_description": "Find your home at Las Palmas—San Diego County apartments close to Naval Medical Center featuring modern amenities perfect for military families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-balboa-park-san-diego-las-palmas",
      "search_query": "apartments near Balboa Park San Diego",
      "category": "Park",
      "h1_title": "Apartments Near Balboa Park, San Diego",
      "h2_subtitle": "Discover Las Palmas, offering apartments near Balboa Park, San Diego. Experience vibrant living close to cultural and recreational attractions.",
      "page_copy": "Located in the charming Talmadge neighborhood, Las Palmas is the perfect spot for those seeking apartments near Balboa Park in San Diego. Our community offers easy access to the park's lush gardens, museums, and unique attractions, making it ideal for those who love culture and nature.\n\nLas Palmas boasts Spanish Revival architecture with all the modern conveniences you desire. Residents enjoy stainless steel appliances, in-unit washer/dryers, and quiet dual pane windows. The cable and internet-ready units at Las Palmas ensure you stay connected while enjoying a tranquil living environment. Embrace the vibrancy of living near Balboa Park while enjoying the comfort and style of our community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Balboa Park, San Diego",
      "seo_description": "Live near the vibrant Balboa Park at Las Palmas. Offering apartments with modern amenities in San Diego's charming Talmadge neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-close-to-waterfront-park-ca-las-palmas",
      "search_query": "apartments close to Waterfront Park CA",
      "category": "Park",
      "h1_title": "Apartments Close to Waterfront Park, CA",
      "h2_subtitle": "Explore Las Palmas, where our apartments offer proximity to Waterfront Park in CA. Perfect for those who cherish scenic outdoor spaces.",
      "page_copy": "Las Palmas is an excellent choice for anyone seeking apartments close to Waterfront Park, CA. Residing within the picturesque Talmadge neighborhood, our community provides convenient access to the beautiful park where you can enjoy stunning sunset views and outdoor activities.\n\nOur residences feature classic Spanish Revival architecture partnered with modern amenities such as in-unit washer/dryers and stainless steel appliances. The quiet dual pane windows maintain a peaceful atmosphere, while homes come cable and internet-ready, ensuring you're fully connected. Discover the blend of convenience and tranquility at Las Palmas, perfect for affording easy access to the lively Waterfront Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Waterfront Park, CA",
      "seo_description": "Discover Las Palmas—apartments near Waterfront Park, CA. Enjoy modern amenities and easy access to scenic outdoor spaces in San Diego.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "botanical-building-nearby-apartments-san-diego-county",
      "search_query": "Botanical Building nearby apartments San Diego County",
      "category": "Park",
      "h1_title": "Botanical Building Apartments in San Diego",
      "h2_subtitle": "Find your retreat at Las Palmas, offering Botanical Building nearby apartments in San Diego County. Ideal for nature lovers and cultural enthusiasts.",
      "page_copy": "If you're in search of Botanical Building nearby apartments in San Diego County, look no further than Las Palmas in Talmadge. Our charming community provides the perfect blend of convenience and elegance, situated just a short drive from the magnificent Balboa Park and its famed Botanical Building.\n\nLas Palmas dazzles with its Spanish Revival architecture and features modern comforts such as stainless steel appliances and in-unit washer/dryers. The new dual pane windows ensure a peaceful ambiance, while our residences are cable and internet-ready, keeping you connected. Enjoy the tranquility of Talmadge while being close to the lush gardens and cultural vibrancy of the Botanical Building.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Botanical Building Apartments in San Diego",
      "seo_description": "Discover Las Palmas: Botanical Building nearby apartments in San Diego County. Enjoy modern living close to the famous gardens and cultural spots.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-civita-park-talmadge-las-palmas",
      "search_query": "apartments near Civita Park Talmadge",
      "category": "Park",
      "h1_title": "Apartments Near Civita Park, Talmadge",
      "h2_subtitle": "Explore Las Palmas apartments near Civita Park in Talmadge. Perfect blend of vibrant park access and residential comfort.",
      "page_copy": "Las Palmas offers beautiful residences for those seeking apartments near Civita Park, right in the heart of Talmadge. Enjoy the best of both worlds—proximity to a vibrant park with green spaces and a close-knit community.\n\nOur Spanish Revival architecture is paired with premium amenities such as stainless steel appliances, in-unit washer/dryers, and dual pane windows that keep your living space serene. Each apartment is cable and internet-ready, ensuring modern connectivity. Choose Las Palmas for a welcoming community that aligns modern living with the convenience of nearby Civita Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Civita Park, Talmadge",
      "seo_description": "Find Las Palmas apartments near Civita Park, Talmadge. Enjoy modern conveniences and easy park access in a charming neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "chicano-park-nearby-san-diego-apartments-las-palmas",
      "search_query": "Chicano Park nearby San Diego apartments",
      "category": "Park",
      "h1_title": "Chicano Park Nearby San Diego Apartments",
      "h2_subtitle": "Discover Las Palmas, offering San Diego apartments nearby Chicano Park. Perfect for art and culture enthusiasts wanting a unique community vibe.",
      "page_copy": "Las Palmas offers an ideal living environment for those searching for Chicano Park nearby San Diego apartments. Located in the vibrant Talmadge neighborhood, our community provides easy access to the rich cultural tapestry of Chicano Park, renowned for its stunning murals and deep historical significance.\n\nOur residences feature charming Spanish Revival architecture with modern luxuries like stainless steel appliances and in-unit washer/dryers. Dual pane windows ensure a quiet and relaxing home environment, while each apartment is ready for cable and internet setups. Experience San Diego's thriving cultural scene and welcoming community by making Las Palmas your home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chicano Park Nearby San Diego Apartments",
      "seo_description": "Explore Las Palmas apartments near Chicano Park, San Diego. Enjoy modern amenities and cultural richness in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-close-to-county-center-little-italy-station",
      "search_query": "apartments close to county center little italy station san diego",
      "category": "Transit",
      "h1_title": "Apartments Near Little Italy Station, San Diego",
      "h2_subtitle": "Las Palmas offers a prime location with apartments close to County Center Little Italy Station in San Diego. Experience vibrant urban living.",
      "page_copy": "For those looking to live in the heart of San Diego with easy access to transportation, Las Palmas offers apartments close to County Center Little Italy Station. Nestled in Talmadge, our community provides the perfect balance of metropolitan convenience and serene living.\n\nEmbrace the charm of our Spanish Revival design paired with modern amenities such as stainless steel appliances and in-unit washer/dryers. The new dual pane windows ensure your home remains a peaceful retreat from the bustling city, while being cable and internet-ready keeps you connected. Choose Las Palmas and enjoy a dynamic urban lifestyle near all the cultural attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Little Italy Station, San Diego",
      "seo_description": "Discover Las Palmas: Apartments close to County Center Little Italy Station, San Diego. Enjoy urban convenience and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-12th-imperial-station-san-diego-county",
      "search_query": "apartments near 12th imperial station san diego county",
      "category": "Transit",
      "h1_title": "Apartments Near 12th & Imperial Station",
      "h2_subtitle": "Discover Las Palmas, conveniently located with apartments near 12th & Imperial Station in San Diego County. Experience seamless commuting and vibrant living.",
      "page_copy": "Las Palmas is the perfect choice for those seeking apartments near 12th & Imperial Station in San Diego County. Our location in the charming Talmadge area offers easy access to efficient public transportation, connecting you effortlessly to the best of San Diego.\n\nOur community boasts Spanish Revival architecture combined with modern interior features. Enjoy in-unit washer/dryers, stainless steel appliances, and quiet dual pane windows. Each apartment is cable and internet-ready, catering to all your modern lifestyle needs. Choose Las Palmas for a harmonious blend of style, convenience, and access to San Diego's vibrant city life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 12th & Imperial Station, San Diego",
      "seo_description": "Find Las Palmas apartments near 12th & Imperial Station in San Diego County. Enjoy seamless transportation and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-close-to-sdsu-station-talmadge",
      "search_query": "apartments close to sdsu station talmadge",
      "category": "Transit",
      "h1_title": "Apartments Near SDSU Station in Talmadge",
      "h2_subtitle": "Las Palmas offers convenient apartments close to SDSU Station in Talmadge. Ideal for students and professionals seeking ease of commute.",
      "page_copy": "Las Palmas presents an exciting opportunity for those looking for apartments close to SDSU Station in Talmadge. Our location is perfect for students, faculty, and professionals seeking proximity to San Diego State University and convenient public transport options.\n\nOur community features charming Spanish Revival architecture with modern comforts, such as in-unit washer/dryers and stainless steel appliances. Enjoy the tranquility provided by new, quiet dual pane windows, and benefit from cable and internet-ready apartments. Las Palmas offers an ideal blend of accessibility and style, making it a perfect home base near educational and cultural hotspots.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near SDSU Station, Talmadge",
      "seo_description": "Explore Las Palmas: Apartments near SDSU Station in Talmadge. Convenient for students and professionals seeking modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167027",
      "source": "generator",
      "page_item_url": "apartments-near-fashion-valley-station-92115",
      "search_query": "apartments near fashion valley station 92115",
      "category": "Transit",
      "h1_title": "Apartments Near Fashion Valley Station 92115",
      "h2_subtitle": "Explore Las Palmas, offering convenient apartments near Fashion Valley Station in the 92115 area. Enjoy stylish living with ease of access.",
      "page_copy": "Experience the perfect blend of style and convenience with Las Palmas apartments near Fashion Valley Station in 92115. Situated in Talmadge, our community offers effortless access to premier shopping, dining, and entertainment venues, all within a short commute.\n\nRelish the unique Spanish Revival architecture paired with modern amenities like in-unit washer/dryers and stainless steel appliances. Our new dual pane windows ensure a peaceful atmosphere while our cable and internet-ready homes cater to the modern renter's lifestyle. Choose Las Palmas and immerse yourself in a vibrant community near all the attractions of San Diego.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fashion Valley Station 92115",
      "seo_description": "Discover Las Palmas: Apartments near Fashion Valley Station in 92115. Enjoy modern amenities and easy access to San Diego's best.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5733"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18224252884"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W75K5JC9"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.laspalmaslife.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1699391\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "42196890135"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwj5k6zv1e"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "00927850"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "6192571865"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdnbjBDY3lUbWMrSDhSYUlyd2Q0VVE9PSIsInZhbHVlIjoiaGJjZ0IzRVZaZ21jUzlyZ0xjemlNZz09IiwibWFjIjoiNjM3OTA0YjNkYmI5NDJkNDllZjY1YzVlNTIwNjU0NjVlMzIwYjczMzM2NzQ5ZGQ4MjhkNmZhMTBiYWFiZGYyNSJ9"
    }
  ],
  "custom_qb_id": "5733",
  "custom_repli_id": "18224252884",
  "custom_google_gtm_id": "GTM-W75K5JC9",
  "custom_entrata_chatbot": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.laspalmaslife.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1699391\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>",
  "custom_hubspot_company_id": "42196890135",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rxwj5k6zv1e",
  "custom_broker_license_number": "00927850",
  "custom_ppc_tracking_phone_number": "6192571865",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdnbjBDY3lUbWMrSDhSYUlyd2Q0VVE9PSIsInZhbHVlIjoiaGJjZ0IzRVZaZ21jUzlyZ0xjemlNZz09IiwibWFjIjoiNjM3OTA0YjNkYmI5NDJkNDllZjY1YzVlNTIwNjU0NjVlMzIwYjczMzM2NzQ5ZGQ4MjhkNmZhMTBiYWFiZGYyNSJ9"
};

export const generatedAt = '2026-09-25T18:12:49.079Z';
